import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet-draw';
import merge from 'merge';
import 'leaflet-fullscreen';
import 'leaflet.locatecontrol';
import 'leaflet-geometryutil';
import simpleheat from 'simpleheat';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { RpcProvider } from 'worker-rpc';
import * as esri from 'esri-leaflet';
import * as Vector from 'esri-leaflet-vector';

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
L.leafletUtil = {
  boundsToArray: boundsToArray,
  isMultiPolyline: isMultiPolyline,
  isMultiPolygon: isMultiPolygon,
  isPolyline: isPolyline,
  isPath: isPath,
  geometryIsPoint: geometryIsPoint,
  getPathCenter: getPathCenter,
  removeArrayElement: removeArrayElement,
  fitGeometry: fitGeometry,
  fitBounds: fitBounds,
  fitPoint: fitPoint,
  error: error
};

function boundsToArray(bounds) {
  return [bounds.getSouthWest().lat, bounds.getSouthWest().lng, bounds.getNorthEast().lat, bounds.getNorthEast().lng];
}

function isMultiPolyline(el) {
  if (el instanceof L.Polygon) return false;

  if (el instanceof L.Polyline) {
    var latLngs = el.getLatLngs();
    return latLngs[0] && Array.isArray(latLngs[0]);
  }

  return false;
}

function isMultiPolygon(el) {
  if (el instanceof L.Polygon) {
    var latLngs = el.getLatLngs();
    return latLngs[0] && latLngs[0][0] && Array.isArray(latLngs[0][0]);
  }

  return false;
}

function isPolyline(layer) {
  if (typeof layer.getLatLng === "function") return false;
  if (layer instanceof L.Polygon) return false;
  return layer instanceof L.Polyline;
}

function isPath(layer) {
  return typeof layer.getLatLng !== "function";
}

function geometryIsPoint(geometry) {
  return geometry && (geometry.type || "").toLowerCase() === "point";
}

function getPathCenter(map, el) {
  if (el instanceof L.Polygon) {
    return el.getCenter();
  } else if (el instanceof L.Polyline) {
    if (isMultiPolyline(el)) {
      var latLngs = el.getLatLngs();
      var maxLengthSegment = latLngs.reduce(function (prev, current) {
        return prev && prev.length > current.length ? prev : current;
      }, null);
      if (!maxLengthSegment) return null;
      el = L.polyline(_toConsumableArray(maxLengthSegment));
    }

    var segment = L.GeometryUtil.extract(map, el, 0, 0.5);
    return segment.length > 0 ? segment[segment.length - 1] : null;
  }

  return null;
} // Array


function removeArrayElement(array, predicate) {
  var length = array.length;
  var result = array.filter(function (item) {
    return !predicate(item);
  });
  array.splice(0, array.length);
  Array.prototype.push.apply(array, result);
  return length - array.length;
} // Fit Bounds


function fitGeometry(map, geometry, pointAroundMeters, padding) {
  var layer = L.GeoJSON.geometryToLayer(geometry);
  padding = _objectSpread$7({
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }, padding);
  var fitBoundsOptions = {
    paddingTopLeft: [padding.left, padding.top],
    paddingBottomRight: [padding.right, padding.bottom]
  };

  if (typeof layer.getLatLng === "function") {
    var bounds = layer.getLatLng().toBounds(pointAroundMeters);
    map.fitBounds(bounds, fitBoundsOptions);
  } else if (typeof layer.getBounds === "function") {
    map.fitBounds(layer.getBounds(), fitBoundsOptions);
  }
}

function fitBounds(map, bounds, padding) {
  padding = _objectSpread$7({
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }, padding);
  var fitBoundsOptions = {
    paddingTopLeft: [padding.left, padding.top],
    paddingBottomRight: [padding.right, padding.bottom]
  };
  map.fitBounds(bounds, fitBoundsOptions);
}

function fitPoint(map, latLng, pointAroundMeters, padding) {
  padding = _objectSpread$7({
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }, padding);
  var fitBoundsOptions = {
    paddingTopLeft: [padding.left, padding.top],
    paddingBottomRight: [padding.right, padding.bottom]
  };
  var bounds = L.latLng(latLng).toBounds(pointAroundMeters);
  map.fitBounds(bounds, fitBoundsOptions);
} // Log


function error(messageOrError) {
  if (console.error) {
    console.error(messageOrError);
  } else if (console.log) {
    console.log(messageOrError);
  }
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var _superGeometryToLayer = L.GeoJSON.geometryToLayer;

function geometryToLayerExt(geojson, options) {
  var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson;
  var coords = geometry ? geometry.coordinates : null;

  var _coordsToLatLng = options && options.coordsToLatLng || L.GeoJSON.coordsToLatLng;

  var latlng, factory;

  if (!coords && !geometry) {
    return null;
  }

  switch (geometry.type) {
    case 'CircleMarker':
    case 'Circle':
      latlng = _coordsToLatLng(coords);
      factory = geometry.type === 'Circle' ? L.circle : L.circleMarker;
      return factory(latlng, _objectSpread$6(_objectSpread$6({}, options), {}, {
        radius: geometry.radius
      }));

    default:
      return _superGeometryToLayer(geojson, options);
  }
}

L.GeoJSON.geometryToLayer = geometryToLayerExt;

L.Popup.mergeOptions({
  fixWidthPixel: false
});
L.Popup.include({
  _superUpdateLayout: L.Popup.prototype._updateLayout,
  _updateLayout: function _updateLayout() {
    this._superUpdateLayout();

    if (this.options.fixWidthPixel) {
      var container = this._contentNode;
      var style = container.style;
      var width = container.offsetWidth;
      style.width = width - 1 + 'px';
      this._containerWidth = this._container.offsetWidth;
    }
  }
});

L.Marker.include({
  rotate: function rotate(deg) {
    var icon = this.options.icon;

    if (icon && icon.options && icon.options.rotateClass && this._icon) {
      var rotateEl = this._icon.querySelector(".".concat(icon.options.rotateClass));

      if (rotateEl) {
        rotateEl.style.transform = "rotate(".concat(deg, "deg)");
      }
    }
  },
  rotateIcon: function rotateIcon(deg) {
    var icon = this.options.icon;

    if (icon && icon.options && icon.options.rotateIconClass && this._icon) {
      var rotateEl = this._icon.querySelector(".".concat(icon.options.rotateIconClass));

      if (rotateEl) {
        rotateEl.style.transform = "rotate(".concat(deg, "deg)");
      }
    }
  }
});

L.Control.Zoom.mergeOptions({
  position: 'rightcenter'
});

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
L.PathCenterMarker = L.Marker.extend({
  initialize: function initialize(options) {
    L.Marker.prototype.initialize.call(this, [0, 0], options);
    this.placeMarkerHandler = this.onPlaceMarker.bind(this);
    this.removeMarkerHandler = this.onRemoveMarker.bind(this);
  },
  attachTo: function attachTo(layer) {
    layer.on("add", this.placeMarkerHandler);
    layer.on("remove", this.removeMarkerHandler);
  },
  detachFrom: function detachFrom(layer) {
    layer.off("add", this.placeMarkerHandler);
    layer.off("remove", this.removeMarkerHandler);
  },
  onPlaceMarker: function onPlaceMarker(e) {
    var target = e.target;

    if (target._map) {
      var center = L.leafletUtil.getPathCenter(target._map, target);

      if (center) {
        this.setLatLng(center);
        this.addTo(target._map);
        this._eventParents = _objectSpread$5({}, target._eventParents);
        target._centerMarker = this;
      }
    }
  },
  onRemoveMarker: function onRemoveMarker(e) {
    e.target._centerMarker = null;
    this._eventParents = {};
    this.remove();
  }
});

L.pathCenterMarker = function (options) {
  return new L.PathCenterMarker(options);
};

var addControlPosition = function addControlPosition(controlContainer, controlCorners, positionName, classNames) {
  var posEl = L.DomUtil.create("div", classNames);
  controlContainer.appendChild(posEl);
  controlCorners[positionName] = posEl;
};

L.Map.include({
  _superInitControlPos: L.Map.prototype._initControlPos,
  _initControlPos: function _initControlPos() {
    this._superInitControlPos();

    if (this._controlContainer && this._controlCorners) {
      addControlPosition(this._controlContainer, this._controlCorners, "htophleft", "leaflet-htop leaflet-hleft");
      addControlPosition(this._controlContainer, this._controlCorners, "htophright", "leaflet-htop leaflet-hright");
      addControlPosition(this._controlContainer, this._controlCorners, "hbottomhleft", "leaflet-hbottom leaflet-hleft");
      addControlPosition(this._controlContainer, this._controlCorners, "hbottomhright", "leaflet-hbottom leaflet-hright");
      addControlPosition(this._controlContainer, this._controlCorners, "leftcenter", "leaflet-left leaflet-center");
      addControlPosition(this._controlContainer, this._controlCorners, "rightcenter", "leaflet-right leaflet-center");
    }
  }
});

var LeafletControl = L.Control.extend({
  options: {
    position: "topleft",
    onAdd: function onAdd() {
      return document.createElement("div");
    },
    onRemove: function onRemove() {},
    onDisable: function onDisable() {},
    onEnable: function onEnable() {}
  },
  onAdd: function onAdd(map) {
    var onAdd = this.options.onAdd;
    return onAdd(map);
  },
  onRemove: function onRemove(map) {
    var onRemove = this.options.onRemove;
    return onRemove(map);
  },
  disable: function disable() {
    var onDisable = this.options.onDisable;
    onDisable();
    return this;
  },
  enable: function enable() {
    var onEnable = this.options.onEnable;
    onEnable();
    return this;
  }
});
L.LeafletControl = LeafletControl;

L.Control.CustomScale = L.Control.Scale.extend({
  options: {
    custom: false,
    messages: {
      units: {
        km: "km",
        m: "m"
      }
    }
  },
  _addScales: function _addScales(options, className, container) {
    L.Control.Scale.prototype._addScales.call(this, options, className, container);

    if (this.options.custom) {
      this._cScale = L.DomUtil.create('div', className + "-custom", container);
      this._cScaleLabel = L.DomUtil.create('div', className + "-custom-label", this._cScale);
      L.DomUtil.create('div', className + "-custom-line", this._cScale);
      L.DomUtil.create('div', className + "-custom-edge", this._cScale);
    }
  },
  _updateScales: function _updateScales(maxMeters) {
    L.Control.Scale.prototype._updateScales.call(this, maxMeters);

    if (this.options.custom && maxMeters) {
      this._updateCustom(maxMeters);
    }
  },
  _updateCustom: function _updateCustom(maxMeters) {
    var units = this.options.messages.units;

    var meters = this._getRoundNum(maxMeters);

    var label = meters < 1000 ? meters + ' ' + units.m : meters / 1000 + ' ' + units.km;

    this._updateCustomScale(this._cScale, this._cScaleLabel, label, meters / maxMeters);
  },
  _updateCustomScale: function _updateCustomScale(scale, scaleLabel, text, ratio) {
    scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
    scaleLabel.innerText = text;
  }
});

L.control.customScale = function (options) {
  return new L.Control.CustomScale(options);
};

L.MarkerClusterGroup.include({
  _superZoomOrSpiderfy: L.MarkerClusterGroup.prototype._zoomOrSpiderfy,
  _zoomOrSpiderfy: function _zoomOrSpiderfy(e) {
    if (e._prevented) return;

    this._superZoomOrSpiderfy(e);
  }
});

var ru = {
  draw: {
    toolbar: {
      actions: {
        title: "Отменить рисование",
        text: "Отмена"
      },
      finish: {
        title: "Завершить рисование",
        text: "Завершить"
      },
      undo: {
        title: "Удалить последнюю точку",
        text: "Удалить последнюю точку"
      },
      buttons: {
        polyline: "Нарисовать ломанную",
        polygon: "Нарисовать полигон",
        rectangle: "Нарисовать прямоугольник",
        circle: "Нарисовать круг",
        marker: "Нарисовать точку",
        circlemarker: "Нарисовать круговую точку",
        multipolyline: "Нарисовать ломанную",
        multipolygon: "Нарисовать полигон"
      }
    },
    handlers: {
      circle: {
        tooltip: {
          start: "Нажмите и перетащите, чтобы нарисовать круг."
        },
        radius: "Радиус"
      },
      circlemarker: {
        tooltip: {
          start: "Нажмите на карту, чтобы отметить круговую точку."
        }
      },
      marker: {
        tooltip: {
          start: "Нажмите на карту, чтобы отметить точку."
        }
      },
      polygon: {
        tooltip: {
          start: "Нажмите для начала рисования.",
          cont: "Нажмите для продолжения рисования.",
          end: "Соедините с первой точкой для завершения."
        }
      },
      polyline: {
        error: "<strong>Ошибка:</strong> края фигуры не могут пересекаться!",
        tooltip: {
          start: "Нажмите для начала рисования.",
          cont: "Нажмите для продолжения рисования.",
          end: "Соедините с последней точкой для завершения."
        }
      },
      rectangle: {
        tooltip: {
          start: "Нажмите и перетащите, чтобы нарисовать прямоугольник."
        }
      },
      simpleshape: {
        tooltip: {
          end: "Отпустите мышь, чтобы закончить рисование."
        }
      }
    }
  },
  edit: {
    toolbar: {
      actions: {
        save: {
          title: "Сохранить изменения",
          text: "Сохранить"
        },
        cancel: {
          title: "Отменить все изменения",
          text: "Отменить"
        },
        clearAll: {
          title: "Очистить все",
          text: "Очистить все"
        }
      },
      buttons: {
        edit: "Изменить объект",
        editDisabled: "Нет объектов для изменения",
        remove: "Удалить объекты",
        removeDisabled: "Нет объектов для изменения"
      }
    },
    handlers: {
      edit: {
        tooltip: {
          text: "Переместите для редактирования.",
          subtext: "Нажмите отменить для отмены изменений."
        }
      },
      remove: {
        tooltip: {
          text: "Нажмите на объект для удаления."
        }
      }
    }
  }
};

var en = merge.recursive(true, L.drawLocal, {
  draw: {
    toolbar: {
      buttons: {
        multipolyline: "Draw a multi polyline",
        multipolygon: "Draw a multi polygon"
      }
    }
  }
});

var defaultLang = "en";
var langs = {
  en: en,
  ru: ru
};
function setDrawLocale(lang) {
  var fallbackLang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
  L.drawLocal = langs[lang] || lang[fallbackLang] || lang[defaultLang];
}
L.setDrawLocale = setDrawLocale;
setDrawLocale(defaultLang);

L.Draw.Marker.include({
  _superCreateMarker: L.Draw.Marker.prototype._createMarker,
  _createMarker: function _createMarker(latlng) {
    if (this.options.pane) {
      return new L.Marker(latlng, {
        icon: this.options.icon,
        zIndexOffset: this.options.zIndexOffset,
        pane: this.options.pane
      });
    } else {
      return this._superCreateMarker(latlng);
    }
  }
});
L.Draw.Polyline.include({
  _shapeIsValid: function _shapeIsValid() {
    var latlngs = this._poly._defaultShape ? this._poly._defaultShape() : this._poly.getLatLngs();
    return latlngs.length > 1;
  }
});

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
L.DrawToolbar.mergeOptions({
  multipolyline: {},
  multipolygon: {}
});
L.DrawToolbar.include({
  _superGetModeHandlers: L.DrawToolbar.prototype.getModeHandlers,
  getModeHandlers: function getModeHandlers(map) {
    var modes = this._superGetModeHandlers(map);

    modes.push({
      enabled: this.options.multipolyline,
      handler: new L.Draw.MultiPolyline(map, this.options.multipolyline),
      title: L.drawLocal.draw.toolbar.buttons.multipolyline
    });
    modes.push({
      enabled: this.options.multipolygon,
      handler: new L.Draw.MultiPolygon(map, this.options.multipolygon),
      title: L.drawLocal.draw.toolbar.buttons.multipolygon
    });
    return modes;
  }
});
L.Draw.Polyline.include({
  _calculateFinishDistance: function _calculateFinishDistance(potentialLatLng) {
    var lastPtDistance;

    if (this._markers.length > 0) {
      var finishMarker;

      if (this.type === L.Draw.Polyline.TYPE || this.type === L.Draw.MultiPolyline.TYPE) {
        finishMarker = this._markers[this._markers.length - 1];
      } else if (this.type === L.Draw.Polygon.TYPE || this.type === L.Draw.MultiPolygon.TYPE) {
        finishMarker = this._markers[0];
      } else {
        return Infinity;
      }

      var lastMarkerPoint = this._map.latLngToContainerPoint(finishMarker.getLatLng());

      var potentialMarker = new L.Marker(potentialLatLng, {
        icon: this.options.icon,
        zIndexOffset: this.options.zIndexOffset * 2
      });

      var potentialMarkerPint = this._map.latLngToContainerPoint(potentialMarker.getLatLng());

      lastPtDistance = lastMarkerPoint.distanceTo(potentialMarkerPint);
    } else {
      lastPtDistance = Infinity;
    }

    return lastPtDistance;
  }
});
L.Draw.MultiPolyline = L.Draw.Polyline.extend({
  statics: {
    TYPE: 'multipolyline'
  },
  initialize: function initialize(map, options) {
    L.Draw.Polyline.prototype.initialize.call(this, map, options);
    this.type = L.Draw.MultiPolyline.TYPE;
  },
  addHooks: function addHooks() {
    L.Draw.Polyline.prototype.addHooks.call(this);

    if (this._map) {
      if (!this._noResetGroup) {
        this._multiLayerGroup = new L.Draw.MultiLayerGroup();

        this._map.addLayer(this._multiLayerGroup);
      }
    }
  },
  removeHooks: function removeHooks() {
    L.Draw.Polyline.prototype.removeHooks.call(this);

    if (!this._noResetGroup) {
      this._map.removeLayer(this._multiLayerGroup);

      delete this._multiLayerGroup;
    }
  },
  completeShape: function completeShape() {
    var shapeIsInvalid = this._markers.length <= 1 || !this._shapeIsValid();

    var layerCount = this._multiLayerGroup.getLayers().length;

    if (this._markers.length === 0 && layerCount > 0) {
      this._fireCreatedEvent();

      this.disable();
      return;
    }

    if (shapeIsInvalid) {
      return;
    }

    this._addPolyToLayerGroup();

    this._fireCreatedEvent();

    this.disable();
  },
  _finishShape: function _finishShape() {
    var latlngs = this._poly._defaultShape ? this._poly._defaultShape() : this._poly.getLatLngs();

    var intersects = this._poly.newLatLngIntersects(latlngs[latlngs.length - 1]);

    if (!this.options.allowIntersection && intersects || !this._shapeIsValid()) {
      this._showErrorTooltip();

      return;
    }

    this._addPolyToLayerGroup();

    this._noResetGroup = true;
    this.disable();
    this.enable();
    this._noResetGroup = false;
  },
  _addPolyToLayerGroup: function _addPolyToLayerGroup() {
    var poly = new this.Poly(this._poly.getLatLngs(), this.options.shapeOptions);

    this._multiLayerGroup.addLayer(poly);
  },
  _fireCreatedEvent: function _fireCreatedEvent() {
    var poly = new this.Poly(this._multiLayerGroup.getLatLngs(), this.options.shapeOptions);

    L.Draw.Feature.prototype._fireCreatedEvent.call(this, poly);
  }
});
L.Draw.MultiPolygon = L.Draw.Polygon.extend({
  statics: {
    TYPE: 'multipolygon'
  },
  initialize: function initialize(map, options) {
    L.Draw.Polygon.prototype.initialize.call(this, map, options);
    this.type = L.Draw.MultiPolygon.TYPE;
  },
  addHooks: function addHooks() {
    L.Draw.MultiPolyline.prototype.addHooks.call(this);
  },
  removeHooks: function removeHooks() {
    L.Draw.MultiPolyline.prototype.removeHooks.call(this);
  },
  completeShape: function completeShape() {
    L.Draw.MultiPolyline.prototype.completeShape.call(this);
  },
  _finishShape: function _finishShape() {
    L.Draw.MultiPolyline.prototype._finishShape.call(this);
  },
  _addPolyToLayerGroup: function _addPolyToLayerGroup() {
    L.Draw.MultiPolyline.prototype._addPolyToLayerGroup.call(this);
  },
  _fireCreatedEvent: function _fireCreatedEvent() {
    L.Draw.MultiPolyline.prototype._fireCreatedEvent.call(this);
  }
});
L.Draw.MultiLayerGroup = L.LayerGroup.extend({
  getLatLngs: function getLatLngs() {
    return this.getLayers().map(function (layer) {
      return layer.getLatLngs();
    });
  }
});
var splitMultiPoly = function splitMultiPoly(layerGroup) {
  var multiPolygons = layerGroup.getLayers().filter(function (l) {
    return L.leafletUtil.isMultiPolygon(l);
  });
  var multiPolylines = layerGroup.getLayers().filter(function (l) {
    return L.leafletUtil.isMultiPolyline(l);
  });

  var split = function split(PolyConstructor, layer) {
    var latlngs = layer.getLatLngs();

    var _multiLayerGroup = new L.Draw.MultiLayerGroup();

    _multiLayerGroup.options._partitionLayerOptions = _objectSpread$4({}, layer.options);
    _multiLayerGroup.options._partitionLayerConstructor = PolyConstructor;

    for (var i = 0; i < latlngs.length; i++) {
      var part = new PolyConstructor(latlngs[i], _objectSpread$4(_objectSpread$4({}, layer.options), {}, {
        _multiLayerGroup: _multiLayerGroup
      }));

      _multiLayerGroup.addLayer(part);
    }

    layerGroup.removeLayer(layer);

    _multiLayerGroup.getLayers().forEach(function (l) {
      layerGroup.addLayer(l);
    });
  };

  multiPolygons.forEach(function (layer) {
    split(L.Polygon, layer);
  });
  multiPolylines.forEach(function (layer) {
    split(L.Polyline, layer);
  });
};
var joinMultiPoly = function joinMultiPoly(layerGroup) {
  var multiLayerGroups = layerGroup.getLayers().map(function (l) {
    return l.options._multiLayerGroup;
  }).filter(function (l) {
    return l != null;
  });
  multiLayerGroups = multiLayerGroups.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });

  var join = function join(multiPartGroup) {
    var _multiPartGroup$optio = multiPartGroup.options,
        _partitionLayerOptions = _multiPartGroup$optio._partitionLayerOptions,
        _partitionLayerConstructor = _multiPartGroup$optio._partitionLayerConstructor;
    var poly = new _partitionLayerConstructor(multiPartGroup.getLatLngs(), _objectSpread$4({}, _partitionLayerOptions));
    multiPartGroup.getLayers().forEach(function (layer) {
      layerGroup.removeLayer(layer);
      delete layer.options._multiLayerGroup;
    });
    multiPartGroup.clearLayers();
    delete multiPartGroup.options._partitionLayerOptions;
    delete multiPartGroup.options._partitionLayerConstructor;
    layerGroup.addLayer(poly);
  };

  multiLayerGroups.forEach(function (g) {
    return join(g);
  });
};
L.EditToolbar.Edit.include({
  _superInit: L.EditToolbar.Edit.prototype.initialize,
  initialize: function initialize(map, options) {
    var _this = this;

    this._superInit(map, options);

    var onEnabled = function onEnabled() {
      splitMultiPoly(_this._featureGroup);
    };

    var onDisabled = function onDisabled() {
      joinMultiPoly(_this._featureGroup);
    };

    this.on("enabled", onEnabled).on("disabled", onDisabled);
  },
  save: function save() {
    var editedLayers = new L.LayerGroup();
    var multiPartGroups = [];

    this._featureGroup.eachLayer(function (layer) {
      if (layer.edited) {
        if (layer.options._multiLayerGroup) {
          if (multiPartGroups.indexOf(layer.options._multiLayerGroup) === -1) {
            multiPartGroups.push(layer.options._multiLayerGroup);
          }
        } else {
          editedLayers.addLayer(layer);
        }

        layer.edited = false;
      }
    });

    multiPartGroups.forEach(function (g) {
      var _g$options = g.options,
          _partitionLayerOptions = _g$options._partitionLayerOptions,
          _partitionLayerConstructor = _g$options._partitionLayerConstructor;
      var poly = new _partitionLayerConstructor(g.getLatLngs(), _objectSpread$4({}, _partitionLayerOptions));
      editedLayers.addLayer(poly);
    });

    this._map.fire(L.Draw.Event.EDITED, {
      layers: editedLayers
    });
  }
});

L.Map.include({
  _superSetFullscreen: L.Map.prototype._setFullscreen,
  toggleFullscreen: function toggleFullscreen(options) {
    this._lastFullscreenOptions = options;
    var container = this._getCustomFullscreenElement(options) || this.getContainer();

    if (this.isFullscreen()) {
      if (options && options.pseudoFullscreen) {
        this._disablePseudoFullscreen(container);
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else {
        this._disablePseudoFullscreen(container);
      }
    } else {
      if (options && options.pseudoFullscreen) {
        this._enablePseudoFullscreen(container);
      } else if (container.requestFullscreen) {
        container.requestFullscreen();
      } else if (container.mozRequestFullScreen) {
        container.mozRequestFullScreen();
      } else if (container.webkitRequestFullscreen) {
        container.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (container.msRequestFullscreen) {
        container.msRequestFullscreen();
      } else {
        this._enablePseudoFullscreen(container);
      }
    }
  },
  _getCustomFullscreenElement: function _getCustomFullscreenElement(options) {
    if (options) {
      if (options.containerId) {
        return document.getElementById(options.containerId);
      } else if (options.containerElement) {
        return options.containerElement;
      }
    }

    return null;
  },
  _setFullscreen: function _setFullscreen(fullscreen) {
    this._superSetFullscreen(fullscreen);

    var options = this._lastFullscreenOptions;

    var customElement = this._getCustomFullscreenElement(options);

    if (options && customElement && options.activeCssClass) {
      if (fullscreen) {
        L.DomUtil.addClass(customElement, options.activeCssClass);
      } else {
        L.DomUtil.removeClass(customElement, options.activeCssClass);
      }
    }
  },
  _onFullscreenChange: function _onFullscreenChange(e) {
    var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    var container = this._getCustomFullscreenElement(this._lastFullscreenOptions) || this.getContainer();

    if (fullscreenElement === container && !this._isFullscreen) {
      this._setFullscreen(true);

      this.fire("fullscreenchange");
    } else if (fullscreenElement !== container && this._isFullscreen) {
      this._setFullscreen(false);

      this.fire("fullscreenchange");
    }
  }
});

L.Google = L.Layer.extend({
  includes: L.Evented ? L.Evented.prototype : L.Mixin.Events,
  options: {
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,
    subdomains: "abc",
    errorTileUrl: "",
    attribution: "",
    opacity: 1,
    continuousWorld: false,
    noWrap: false
  },
  // Possible types: SATELLITE, ROADMAP, HYBRID, TERRAIN
  initialize: function initialize(type, options) {
    L.Util.setOptions(this, options);
    this._type = type || "SATELLITE";
  },
  onAdd: function onAdd(map, insertAtTheBottom) {
    this._map = map;
    this._insertAtTheBottom = insertAtTheBottom; // create a container div for tiles

    this._initContainer();

    this._initMapObject(); // set up events


    map.on("viewreset", this._resetCallback, this);
    map.on("move", this._onMove, this);
    map.on("zoomanim", this._onZoomAnim, this);

    if (map._controlCorners && map._controlCorners.bottomright) {
      map._controlCorners.bottomright.style.marginBottom = "1em";
    }

    this._reset();

    this._update();
  },
  beforeAdd: function beforeAdd(map) {
    map._addZoomLimit(this);
  },
  onRemove: function onRemove(map) {
    this._map._container.removeChild(this._container);

    this._map.off("viewreset", this._resetCallback, this);

    this._map.off("move", this._onMove, this);

    this._map.off("zoomanim", this._onZoomAnim, this);

    if (map._controlCorners && map._controlCorners.bottomright) {
      map._controlCorners.bottomright.style.marginBottom = "0";
    }
  },
  getAttribution: function getAttribution() {
    return this.options.attribution;
  },
  setOpacity: function setOpacity(opacity) {
    this.options.opacity = opacity;

    if (opacity < 1) {
      L.DomUtil.setOpacity(this._container, opacity);
    }
  },
  setElementSize: function setElementSize(e, size) {
    e.style.width = size.x + "px";
    e.style.height = size.y + "px";
  },
  _initContainer: function _initContainer() {
    var tilePane = this._map._container;
    var first = tilePane.firstChild;

    if (!this._container) {
      this._container = L.DomUtil.create("div", "leaflet-google-layer");
      this._container.id = "_GMapContainer_" + L.Util.stamp(this);
      this._container.style.zIndex = "auto";
    }

    tilePane.insertBefore(this._container, first);
    this.setOpacity(this.options.opacity);
    this.setElementSize(this._container, this._map.getSize());
  },
  _initMapObject: function _initMapObject() {
    var _this2 = this;

    if (!window.google) {
      // if no google scripts wait 2 sec
      setTimeout(function () {
        _this2._initMapObject();
      }, 2000);
      return;
    }

    this._google_center = new window.google.maps.LatLng(0, 0);
    var map = new window.google.maps.Map(this._container, {
      center: this._google_center,
      zoom: 0,
      tilt: 0,
      mapTypeId: window.google.maps.MapTypeId[this._type],
      disableDefaultUI: true,
      keyboardShortcuts: false,
      draggable: false,
      disableDoubleClickZoom: true,
      scrollwheel: false,
      streetViewControl: false,
      clickableIcons: false
    });

    var _this = this;

    this._reposition = window.google.maps.event.addListenerOnce(map, "center_changed", function () {
      _this.onReposition();
    });
    map.backgroundColor = "#ff0000";
    this._google = map;
  },
  _resetCallback: function _resetCallback(e) {
    this._reset(e.hard);
  },
  _reset: function _reset() {
    this._initContainer();
  },
  _update: function _update() {
    var inCenter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var inZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!this._google) return;

    if (this._zoomChanged) {
      this._zoomChanged = false;
      return;
    }

    this._resize();

    var center = inCenter || this._map.getCenter();

    var _center = new window.google.maps.LatLng(center.lat, center.lng);

    var zoom = inZoom == null ? this._map.getZoom() : inZoom;

    this._google.setCenter(_center);

    this._google.setZoom(zoom);
  },
  _resize: function _resize() {
    var size = this._map.getSize(); // eslint-disable-next-line eqeqeq


    if (this._container.style.width == size.x && this._container.style.height == size.y) {
      return;
    }

    this.setElementSize(this._container, size);
    this.onReposition();
  },
  onReposition: function onReposition() {
    if (!this._google) return;
    window.google.maps.event.trigger(this._google, "resize");
  },
  _onMove: function _onMove() {
    this._update();
  },
  _onZoomAnim: function _onZoomAnim(_ref) {
    var center = _ref.center,
        zoom = _ref.zoom;

    this._update(center, zoom);

    this._zoomChanged = true;
  }
});

L.Yandex = L.Layer.extend({
  includes: L.Evented ? L.Evented.prototype : L.Mixin.Events,
  options: {
    minZoom: 0,
    maxZoom: 19,
    attribution: "",
    opacity: 1,
    traffic: false
  },
  possibleShortMapTypes: {
    schemaMap: "map",
    satelliteMap: "satellite",
    hybridMap: "hybrid",
    publicMap: "publicMap",
    publicMapInHybridView: "publicMapHybrid"
  },
  _getPossibleMapType: function _getPossibleMapType(mapType) {
    var result = "yandex#map";

    if (typeof mapType !== "string") {
      return result;
    }

    for (var key in this.possibleShortMapTypes) {
      if (mapType === this.possibleShortMapTypes[key]) {
        result = "yandex#" + mapType;
        break;
      }

      if (mapType === "yandex#" + this.possibleShortMapTypes[key]) {
        result = mapType;
      }
    }

    return result;
  },
  // Possible types: yandex#map, yandex#satellite, yandex#hybrid, yandex#publicMap, yandex#publicMapHybrid
  // Or their short names: map, satellite, hybrid, publicMap, publicMapHybrid
  initialize: function initialize(type, options) {
    L.Util.setOptions(this, options); // Assigning an initial map type for the Yandex layer

    this._type = this._getPossibleMapType(type);
  },
  onAdd: function onAdd(map, insertAtTheBottom) {
    this._map = map;
    this._insertAtTheBottom = insertAtTheBottom; // create a container div for tiles

    this._initContainer();

    this._initMapObject(); // set up events


    map.on("viewreset", this._reset, this);
    map.on("move", this._onMove, this);
    map.on("zoomanim", this._onZoomAnim, this);

    if (map._controlCorners && map._controlCorners.bottomright) {
      map._controlCorners.bottomright.style.marginBottom = "1em";
    }

    this._reset();

    this._update(true);
  },
  beforeAdd: function beforeAdd(map) {
    map._addZoomLimit(this);
  },
  onRemove: function onRemove(map) {
    this._map._container.removeChild(this._container);

    this._map.off("viewreset", this._reset, this);

    this._map.off("move", this._onMove, this);

    this._map.off("zoomanim", this._onZoomAnim, this);

    if (map._controlCorners && map._controlCorners.bottomright) {
      map._controlCorners.bottomright.style.marginBottom = "0";
    }
  },
  getAttribution: function getAttribution() {
    return this.options.attribution;
  },
  setOpacity: function setOpacity(opacity) {
    this.options.opacity = opacity;

    if (opacity < 1) {
      L.DomUtil.setOpacity(this._container, opacity);
    }
  },
  setElementSize: function setElementSize(e, size) {
    e.style.width = size.x + "px";
    e.style.height = size.y + "px";
  },
  _initContainer: function _initContainer() {
    var tilePane = this._map._container;
    var first = tilePane.firstChild;

    if (!this._container) {
      this._container = L.DomUtil.create("div", "leaflet-yandex-layer");
      this._container.id = "_YMapContainer_" + L.Util.stamp(this);
      this._container.style.zIndex = "auto";
    }

    if (this.options.overlay) {
      first = this._map._container.getElementsByClassName("leaflet-map-pane")[0];
      first = first.nextSibling; // XXX: Bug with layer order

      if (L.Browser.opera) {
        this._container.className += " leaflet-objects-pane";
      }
    }

    tilePane.insertBefore(this._container, first);
    this.setOpacity(this.options.opacity);
    this.setElementSize(this._container, this._map.getSize());
  },
  _initMapObject: function _initMapObject() {
    var _this = this;

    if (this._yandex) return;

    if (!window.ymaps) {
      // if no yndex map scripts wait 2 sec
      setTimeout(function () {
        _this._initMapObject();
      }, 2000);
      return;
    } // Check that ymaps.Map is ready


    if (window.ymaps.Map === undefined) {
      return window.ymaps.load(["package.map"], this._initMapObject, this);
    } // If traffic layer is requested check if control.TrafficControl is ready


    if (this.options.traffic) {
      if (window.ymaps.control === undefined || window.ymaps.control.TrafficControl === undefined) {
        return window.ymaps.load(["package.traffic", "package.controls"], this._initMapObject, this);
      }
    } // Creating ymaps map-object without any default controls on it


    var map = new window.ymaps.Map(this._container, {
      center: [0, 0],
      zoom: 0,
      behaviors: [],
      controls: []
    });

    if (this.options.traffic) {
      map.controls.add(new window.ymaps.control.TrafficControl({
        shown: true
      }));
    }

    if (this._type === "yandex#null") {
      this._type = new window.ymaps.MapType("null", []);
      map.container.getElement().style.background = "transparent";
    }

    map.setType(this._type);
    this._yandex = map;

    this._update(true); // Reporting that map-object was initialized


    this.fire("MapObjectInitialized", {
      mapObject: map
    });
  },
  _reset: function _reset() {
    this._initContainer();
  },
  _update: function _update(force) {
    var inCenter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var inZoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (!this._yandex || !this._map) return;

    if (this._zoomChanged) {
      this._zoomChanged = false;
      return;
    }

    this._resize(force);

    var center = inCenter || this._map.getCenter();

    var _center = [center.lat, center.lng];
    var zoom = inZoom == null ? this._map.getZoom() : inZoom;

    this._yandex.setCenter(_center, zoom);
  },
  _resize: function _resize(force) {
    if (!this._map) return;

    var size = this._map.getSize();

    var style = this._container.style;

    if (style.width === size.x + "px" && style.height === size.y + "px") {
      if (force !== true) return;
    }

    this.setElementSize(this._container, size);

    this._yandex.container.fitToViewport();
  },
  _onMove: function _onMove() {
    this._update();
  },
  _onZoomAnim: function _onZoomAnim(_ref) {
    var center = _ref.center,
        zoom = _ref.zoom;

    this._update(undefined, center, zoom);

    this._zoomChanged = true;
  }
});

L.HeatLayer = L.Layer.extend({
  // Default Options

  /*
  options: {
    minOpacity: 0.05,
    maxZoom: 18,
    radius: 25,
    blur: 15,
    max: 1.0
  },
  */
  initialize: function initialize(latlngs, options) {
    this._latlngs = latlngs;
    L.setOptions(this, options);
  },
  setLatLngs: function setLatLngs(latlngs) {
    this._latlngs = latlngs;
    return this.redraw();
  },
  addLatLng: function addLatLng(latlng) {
    this._latlngs.push(latlng);

    return this.redraw();
  },
  removeLatLng: function removeLatLng(predicate) {
    var removedLength = L.leafletUtil.removeArrayElement(this._latlngs, predicate);

    if (removedLength > 0) {
      this.redraw();
    }

    return this;
  },
  setOptions: function setOptions(options) {
    L.setOptions(this, options);

    if (this._heat) {
      this._updateOptions();
    }

    return this.redraw();
  },
  redraw: function redraw() {
    if (this._heat && !this._frame && this._map && !this._map._animating) {
      this._frame = L.Util.requestAnimFrame(this._redraw, this);
    }

    return this;
  },
  onAdd: function onAdd(map) {
    this._map = map;

    if (!this._canvas) {
      this._initCanvas();
    }

    if (this.options.pane) {
      this.getPane().appendChild(this._canvas);
    } else {
      map._panes.overlayPane.appendChild(this._canvas);
    }

    map.on("moveend", this._reset, this);

    if (map.options.zoomAnimation && L.Browser.any3d) {
      map.on("zoomanim", this._animateZoom, this);
    }

    this._reset();
  },
  onRemove: function onRemove(map) {
    if (this.options.pane) {
      this.getPane().removeChild(this._canvas);
    } else {
      map.getPanes().overlayPane.removeChild(this._canvas);
    }

    map.off("moveend", this._reset, this);

    if (map.options.zoomAnimation) {
      map.off("zoomanim", this._animateZoom, this);
    }
  },
  addTo: function addTo(map) {
    map.addLayer(this);
    return this;
  },
  _initCanvas: function _initCanvas() {
    var canvas = this._canvas = L.DomUtil.create("canvas", "leaflet-heatmap-layer leaflet-layer");
    var originProp = L.DomUtil.testProp(["transformOrigin", "WebkitTransformOrigin", "msTransformOrigin"]);
    canvas.style[originProp] = "50% 50%";

    var size = this._map.getSize();

    canvas.width = size.x;
    canvas.height = size.y;
    var animated = this._map.options.zoomAnimation && L.Browser.any3d;
    L.DomUtil.addClass(canvas, "leaflet-zoom-" + (animated ? "animated" : "hide"));
    this._heat = simpleheat(canvas);

    this._updateOptions();
  },
  _updateOptions: function _updateOptions() {
    this._heat.radius(this.options.radius || this._heat.defaultRadius, this.options.blur);

    if (this.options.gradient) {
      this._heat.gradient(this.options.gradient);
    }

    if (this.options.max) {
      this._heat.max(this.options.max);
    }
  },
  _reset: function _reset() {
    var topLeft = this._map.containerPointToLayerPoint([0, 0]);

    L.DomUtil.setPosition(this._canvas, topLeft);

    var size = this._map.getSize();

    if (this._heat._width !== size.x) {
      this._canvas.width = this._heat._width = size.x;
    }

    if (this._heat._height !== size.y) {
      this._canvas.height = this._heat._height = size.y;
    }

    this._redraw();
  },
  _redraw: function _redraw() {
    if (!this._map) {
      return;
    }

    var data = [];
    var r = this._heat._r;

    var size = this._map.getSize();

    var bounds = new L.Bounds(L.point([-r, -r]), size.add([r, r]));
    var max = this.options.max === undefined ? 1 : this.options.max;
    var maxZoom = this.options.maxZoom === undefined ? this._map.getMaxZoom() : this.options.maxZoom;
    var v = 1 / Math.pow(2, Math.max(0, Math.min(maxZoom - this._map.getZoom(), 12)));
    var cellSize = r / 2;
    var grid = [];

    var panePos = this._map._getMapPanePos();

    var offsetX = panePos.x % cellSize;
    var offsetY = panePos.y % cellSize;
    var i;
    var len;
    var p;
    var cell;
    var x;
    var y;
    var j;
    var len2;
    var k;

    for (i = 0, len = this._latlngs.length; i < len; i++) {
      p = this._map.latLngToContainerPoint(this._latlngs[i]);

      if (bounds.contains(p)) {
        x = Math.floor((p.x - offsetX) / cellSize) + 2;
        y = Math.floor((p.y - offsetY) / cellSize) + 2;
        var alt = this._latlngs[i].alt !== undefined ? this._latlngs[i].alt : this._latlngs[i][2] !== undefined ? +this._latlngs[i][2] : 1;
        k = alt * v;
        grid[y] = grid[y] || [];
        cell = grid[y][x];

        if (!cell) {
          grid[y][x] = [p.x, p.y, k];
        } else {
          cell[0] = (cell[0] * cell[2] + p.x * k) / (cell[2] + k); // x

          cell[1] = (cell[1] * cell[2] + p.y * k) / (cell[2] + k); // y

          cell[2] += k; // cumulated intensity value
        }
      }
    }

    for (i = 0, len = grid.length; i < len; i++) {
      if (grid[i]) {
        for (j = 0, len2 = grid[i].length; j < len2; j++) {
          cell = grid[i][j];

          if (cell) {
            data.push([Math.round(cell[0]), Math.round(cell[1]), Math.min(cell[2], max)]);
          }
        }
      }
    }

    this._heat.data(data).draw(this.options.minOpacity);

    this._frame = null;
  },
  _animateZoom: function _animateZoom(e) {
    var scale = this._map.getZoomScale(e.zoom);

    var offset = this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos());

    if (L.DomUtil.setTransform) {
      L.DomUtil.setTransform(this._canvas, offset, scale);
    } else {
      this._canvas.style[L.DomUtil.TRANSFORM] = L.DomUtil.getTranslateString(offset) + " scale(" + scale + ")";
    }
  }
});

L.heatLayer = function (latlngs, options) {
  return new L.HeatLayer(latlngs, options);
};

var layerToLatLng = function layerToLatLng(layer) {
  return typeof layer.getLatLng === "function" ? layer.getLatLng() : null;
};

var layersToLatLngs = function layersToLatLngs(layers) {
  return layers.map(layerToLatLng).filter(function (latLng) {
    return latLng != null;
  });
};

L.HeatLayerGroup = L.HeatLayer.extend({
  initialize: function initialize(layers, options) {
    var _this = this;

    L.HeatLayer.prototype.initialize.call(this, layersToLatLngs(layers || []), options);
    this._layers = {};

    if (layers) {
      layers.forEach(function (layer) {
        var id = _this.getLayerId(layer);

        _this._layers[id] = layer;
      });
    }
  },
  addLayers: function addLayers(layers) {
    var _this2 = this;

    layers = layers || [];
    layers.forEach(function (layer) {
      var id = _this2.getLayerId(layer);

      _this2._layers[id] = layer;
    });
    this.setLatLngs(layersToLatLngs(layers));
    return this;
  },
  addLayer: function addLayer(layer) {
    var id = this.getLayerId(layer);
    this._layers[id] = layer;
    var latLng = layerToLatLng(layer);

    if (latLng) {
      this.addLatLng(latLng);
    }

    return this;
  },
  removeLayer: function removeLayer(layer) {
    var id = layer in this._layers ? layer : this.getLayerId(layer);

    if (this._layers[id]) {
      var latLng = layerToLatLng(this._layers[id]);

      if (latLng) {
        this.removeLatLng(function (val) {
          return val === latLng;
        });
      }
    }

    delete this._layers[id];
    return this;
  },
  hasLayer: function hasLayer(layer) {
    return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
  },
  clearLayers: function clearLayers() {
    this._layers = {};
    this.setLatLngs([]);
    return this;
  },
  invoke: function invoke() {
    return this;
  },
  eachLayer: function eachLayer(method, context) {
    for (var i in this._layers) {
      method.call(context, this._layers[i]);
    }

    return this;
  },
  getLayer: function getLayer(id) {
    return this._layers[id];
  },
  getLayers: function getLayers() {
    var layers = [];
    this.eachLayer(layers.push, layers);
    return layers;
  },
  setZIndex: function setZIndex() {
    return this;
  },
  getLayerId: function getLayerId(layer) {
    return L.stamp(layer);
  }
});

L.heatLayerGroup = function (layers, options) {
  return new L.HeatLayerGroup(layers, options);
};

L.HeatPoint = L.Class.extend({
  options: {
    intensity: undefined
  },
  initialize: function initialize(latlng, options) {
    L.setOptions(this, options);
    this._latlng = L.latLng(latlng);

    if (this._latlng) {
      this._latlng.alt = options.intensity;
    }
  },
  getLatLng: function getLatLng() {
    return this._latlng;
  }
});

L.heatPoint = function (latlng, options) {
  return new L.HeatPoint(latlng, options);
};

L.LayerGroupCache = L.Class.extend({
  initialize: function initialize(layerGroup, predicate, options) {
    L.setOptions(this, options);
    this._layerGroup = layerGroup;
    this._predicate = predicate;
    this._items = {};
  },
  get: function get(id) {
    var layer = this._items[id] ? this._layerGroup.getLayer(this._items[id]) : null;

    if (!layer) {
      layer = this._findById(id);

      if (layer) {
        this._items[id] = this._layerGroup.getLayerId(layer);
      }
    }

    return layer;
  },
  clear: function clear() {
    this._items = {};
  },
  getLayerGroup: function getLayerGroup() {
    return this._layerGroup;
  },
  destroy: function destroy() {
    this.clear();
    this._layerGroup = null;
    this._predicate = null;
  },
  _findById: function _findById(id) {
    var _this = this;

    return this._layerGroup.getLayers().find(function (layer) {
      return _this._predicate(id, layer);
    });
  }
});

L.layerGroupCache = function (layer, predicate, options) {
  return new L.LayerGroupCache(layer, predicate, options);
};

L.interpolatePosition = function (p1, p2, duration, t) {
  var k = t / duration;
  k = k > 0 ? k : 0;
  k = k > 1 ? 1 : k;
  return L.latLng(p1.lat + k * (p2.lat - p1.lat), p1.lng + k * (p2.lng - p1.lng));
};

L.Marker.MovingMarker = L.Marker.extend({
  statics: {
    notStartedState: 0,
    endedState: 1,
    pausedState: 2,
    runState: 3
  },
  options: {
    autostart: false,
    loop: false
  },
  initialize: function initialize(latlngs, durations, options) {
    L.Marker.prototype.initialize.call(this, latlngs[0], options);
    this._latlngs = latlngs.map(function (e) {
      return L.latLng(e);
    });

    if (Array.isArray(durations)) {
      this._durations = durations;
    } else {
      this._durations = this._createDurations(this._latlngs, durations);
    }

    this._currentDuration = 0;
    this._currentIndex = 0;
    this._state = L.Marker.MovingMarker.notStartedState;
    this._startTime = 0;
    this._startTimeStamp = 0;
    this._pauseStartTime = 0;
    this._animId = 0;
    this._animRequested = false;
    this._currentLine = [];
    this._stations = {};
  },
  isRunning: function isRunning() {
    return this._state === L.Marker.MovingMarker.runState;
  },
  isEnded: function isEnded() {
    return this._state === L.Marker.MovingMarker.endedState;
  },
  isStarted: function isStarted() {
    return this._state !== L.Marker.MovingMarker.notStartedState;
  },
  isPaused: function isPaused() {
    return this._state === L.Marker.MovingMarker.pausedState;
  },
  start: function start() {
    if (this.isRunning()) {
      return;
    }

    if (this.isPaused()) {
      this.resume();
    } else {
      this._loadLine(0);

      this._startAnimation();

      this.fire("start");
    }
  },
  resume: function resume() {
    if (!this.isPaused()) {
      return;
    }

    this._currentLine[0] = this.getLatLng();
    this._currentDuration -= this._pauseStartTime - this._startTime;

    this._startAnimation();
  },
  pause: function pause() {
    if (!this.isRunning()) {
      return;
    }

    this._pauseStartTime = Date.now();
    this._state = L.Marker.MovingMarker.pausedState;

    this._stopAnimation();

    this._updatePosition();
  },
  stop: function stop(elapsedTime) {
    if (this.isEnded()) {
      return;
    }

    this._stopAnimation();

    if (typeof elapsedTime === "undefined") {
      elapsedTime = 0;

      this._updatePosition();
    }

    this._state = L.Marker.MovingMarker.endedState;
    this.fire("end", {
      elapsedTime: elapsedTime
    });
  },
  addLatLng: function addLatLng(latlng, duration) {
    this._latlngs.push(L.latLng(latlng));

    this._durations.push(duration);
  },
  moveTo: function moveTo(latlng, duration) {
    this._stopAnimation();

    this._latlngs = [this.getLatLng(), L.latLng(latlng)];
    this._durations = [duration];
    this._state = L.Marker.MovingMarker.notStartedState;
    this.start();
    this.options.loop = false;
  },
  addStation: function addStation(pointIndex, duration) {
    if (pointIndex > this._latlngs.length - 2 || pointIndex < 1) {
      return;
    }

    this._stations[pointIndex] = duration;
  },
  onAdd: function onAdd(map) {
    L.Marker.prototype.onAdd.call(this, map);

    if (this.options.autostart && !this.isStarted()) {
      this.start();
      return;
    }

    if (this.isRunning()) {
      this._resumeAnimation();
    }
  },
  onRemove: function onRemove(map) {
    L.Marker.prototype.onRemove.call(this, map);

    this._stopAnimation();
  },
  _createDurations: function _createDurations(latlngs, duration) {
    var lastIndex = latlngs.length - 1;
    var distances = [];
    var totalDistance = 0;
    var distance = 0;
    var i;

    for (i = 0; i < lastIndex; i++) {
      distance = latlngs[i + 1].distanceTo(latlngs[i]);
      distances.push(distance);
      totalDistance += distance;
    }

    var ratioDuration = duration / totalDistance;
    var durations = [];

    for (i = 0; i < distances.length; i++) {
      durations.push(distances[i] * ratioDuration);
    }

    return durations;
  },
  _startAnimation: function _startAnimation() {
    var _this = this;

    this._state = L.Marker.MovingMarker.runState;
    this._animId = L.Util.requestAnimFrame(function (timestamp) {
      _this._startTime = Date.now();
      _this._startTimeStamp = timestamp;

      _this._animate(timestamp);
    }, this, true);
    this._animRequested = true;
  },
  _resumeAnimation: function _resumeAnimation() {
    var _this2 = this;

    if (!this._animRequested) {
      this._animRequested = true;
      this._animId = L.Util.requestAnimFrame(function (timestamp) {
        _this2._animate(timestamp);
      }, this, true);
    }
  },
  _stopAnimation: function _stopAnimation() {
    if (this._animRequested) {
      L.Util.cancelAnimFrame(this._animId);
      this._animRequested = false;
    }
  },
  _updatePosition: function _updatePosition() {
    var elapsedTime = Date.now() - this._startTime;

    this._animate(this._startTimeStamp + elapsedTime, true);
  },
  _loadLine: function _loadLine(index) {
    this._currentIndex = index;
    this._currentDuration = this._durations[index];
    this._currentLine = this._latlngs.slice(index, index + 2);
    this.fire("animline", {
      line: this._currentLine
    });
  },
  _updateLine: function _updateLine(timestamp) {
    var elapsedTime = timestamp - this._startTimeStamp;

    if (elapsedTime <= this._currentDuration) {
      return elapsedTime;
    }

    var lineIndex = this._currentIndex;
    var lineDuration = this._currentDuration;
    var stationDuration;

    while (elapsedTime > lineDuration) {
      elapsedTime -= lineDuration;
      stationDuration = this._stations[lineIndex + 1];

      if (stationDuration !== undefined) {
        if (elapsedTime < stationDuration) {
          this.setLatLng(this._latlngs[lineIndex + 1]);
          return null;
        }

        elapsedTime -= stationDuration;
      }

      lineIndex++;

      if (lineIndex >= this._latlngs.length - 1) {
        if (this.options.loop) {
          lineIndex = 0;
          this.fire("loop", {
            elapsedTime: elapsedTime
          });
        } else {
          this.setLatLng(this._latlngs[this._latlngs.length - 1]);
          this.stop(elapsedTime);
          return null;
        }
      }

      lineDuration = this._durations[lineIndex];
    }

    this._loadLine(lineIndex);

    this._startTimeStamp = timestamp - elapsedTime;
    this._startTime = Date.now() - elapsedTime;
    return elapsedTime;
  },
  _animate: function _animate(timestamp, noRequestAnim) {
    this._animRequested = false;

    var elapsedTime = this._updateLine(timestamp);

    if (this.isEnded()) {
      return;
    }

    if (elapsedTime != null) {
      var p = L.interpolatePosition(this._currentLine[0], this._currentLine[1], this._currentDuration, elapsedTime);
      this.setLatLng(p);
    }

    if (!noRequestAnim) {
      this._animId = L.Util.requestAnimFrame(this._animate, this, false);
      this._animRequested = true;
    }
  }
});

L.Marker.movingMarker = function (latlngs, duration, options) {
  return new L.Marker.MovingMarker(latlngs, duration, options);
};

L.Marker.MovingMarker.addInitHook(function () {
  var _this = this;

  var canRotate = typeof this.rotate === "function" && typeof this.rotateIcon === "function";

  if (canRotate) {
    this.on("animline", function (_ref) {
      var line = _ref.line;

      if (line[0] && line[1]) {
        var angleDeg = L.GeometryUtil.bearing(line[0], line[1]) - 90;

        _this.rotate(angleDeg);

        _this.rotateIcon(-angleDeg);

        _this._rotateAngle = angleDeg;
      }
    });
  }

  var initRotate = function initRotate() {
    if (canRotate && _this._rotateAngle != null) {
      _this.rotate(_this._rotateAngle);

      _this.rotateIcon(-_this._rotateAngle);
    }
  };

  var onZoomStart = function onZoomStart() {
    _this.pause();
  };

  var onZoomEnd = function onZoomEnd() {
    _this.resume();
  };

  var onAdd = function onAdd() {
    initRotate();

    _this._map.on("zoomstart", onZoomStart).on("zoomend", onZoomEnd);
  };

  var onRemove = function onRemove() {
    _this._map.off("zoomstart", onZoomStart).off("zoomend", onZoomEnd);
  };

  this.on("add", onAdd).on("remove", onRemove);
});

L.Marker.MovingMarker.addInitHook(function () {
  var _this = this;

  this.on("add", function () {
    _this._initConnState();
  });
});
L.Marker.MovingMarker.include({
  setConnState: function setConnState(connState, connStateCssPrefix) {
    if (connStateCssPrefix !== undefined) {
      this.options.connStateCssPrefix = connStateCssPrefix;
    }

    this._updateConnState(connState);
  },
  _initConnState: function _initConnState() {
    this._updateConnState(this.options.connState);
  },
  _updateConnState: function _updateConnState(connState) {
    var oldConnState = this.options.connState;
    this.options.connState = connState;
    if (!this._icon) return;

    if (oldConnState) {
      L.DomUtil.removeClass(this._icon, this._getConnStateClassName(oldConnState));
    }

    if (connState) {
      L.DomUtil.addClass(this._icon, this._getConnStateClassName(connState));
    }
  },
  _getConnStateClassName: function _getConnStateClassName(state) {
    var _this$options$connSta;

    return "".concat((_this$options$connSta = this.options.connStateCssPrefix) !== null && _this$options$connSta !== void 0 ? _this$options$connSta : '').concat(state);
  }
});

var TrackerConnState = Object.freeze({
  None: "none",
  Connected: "connected",
  Disconnected: "disconnected"
});
L.Tracker = L.Class.extend({
  statics: {
    ConnState: TrackerConnState
  },
  options: {
    defaultSpeed: 60,
    connStateCssPrefix: "",
    closePopup: false,
    gcCoordsLength: 500,
    maxPositionLagInM: 500,
    usePositionCorrection: false,
    maxZeroSpeedPositionLagInM: 10,
    useZeroSpeedPositionLag: true,
    zeroSpeedCorrection: false
  },
  initialize: function initialize(layerGroupCache, options) {
    L.setOptions(this, options);
    this._layerGroupCache = layerGroupCache;

    if (this.options.usePositionCorrection) {
      var layerGroup = this._layerGroupCache.getLayerGroup();

      this._moveHandler = L.Util.bind(this._onMove, this);
      layerGroup.on("move", this._moveHandler);
    }
  },
  getLayerGroupCache: function getLayerGroupCache() {
    return this._layerGroupCache;
  },
  correctPosition: function correctPosition(id) {
    var layer = this._layerGroupCache.get(id);

    if (!layer) return false;
    return this._handlePositionCorrection(layer);
  },
  updateState: function updateState(id, state) {
    var layer = this._layerGroupCache.get(id);

    if (!layer) return;
    layer.setConnState(state, this.options.connStateCssPrefix);
    return this;
  },
  updatePosition: function updatePosition(id, position) {
    var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var layer = this._layerGroupCache.get(id);

    if (!layer || !position) return;

    var latlng = this._convertPositionToLatLng(position);

    if (!latlng) return;

    if (this.options.closePopup) {
      this._closePopupIfNeeded(layer);
    }

    if (layer instanceof L.Marker.MovingMarker) {
      this._updateMovingMarker(layer, latlng, speed, duration);
    } else if (typeof layer.setLatLng === "function") {
      layer.setLatLng(latlng);
    }

    return this;
  },
  setPosition: function setPosition(id, position) {
    var layer = this._layerGroupCache.get(id);

    if (!layer || !position) return;

    this._setLayerPosition(layer, position);

    return this;
  },
  stopMoving: function stopMoving(id) {
    var layer = this._layerGroupCache.get(id);

    if (!layer) return;

    this._stopLayerMoving(layer);

    return this;
  },
  closePopup: function closePopup(id) {
    var layer = this._layerGroupCache.get(id);

    if (!layer) return;

    this._closePopupIfNeeded(layer);

    return this;
  },
  _updateMovingMarker: function _updateMovingMarker(layer, latlng, speed, duration) {
    var _layer$options$lastPo, _duration;

    var prevPosition = (_layer$options$lastPo = layer.options.lastPosition) !== null && _layer$options$lastPo !== void 0 ? _layer$options$lastPo : layer.getLatLng();
    var prevSpeed = layer.options.lastSpeed;
    var defaultSpeed = this.options.defaultSpeed;
    duration = (_duration = duration) !== null && _duration !== void 0 ? _duration : this._computeDuration(latlng, speed, defaultSpeed, prevSpeed, prevPosition);
    var updated = false;

    if (layer.isRunning() || layer.isPaused()) {
      if (layer._latlngs.length >= this.options.gcCoordsLength) {
        layer.moveTo(latlng, duration);
      } else {
        layer.addLatLng(latlng, duration);
      }

      updated = true;
    } else if (!layer.isStarted() || layer.isEnded()) {
      layer.moveTo(latlng, duration);
      updated = true;
    }

    if (updated) {
      layer.options.lastPosition = latlng.clone();
      layer.options.lastSpeed = speed;
    }
  },
  _computeDuration: function _computeDuration(latlng, speed, defaultSpeed, prevSpeed, prevPosition) {
    prevSpeed = prevSpeed || 0;
    var nextSpeed = speed || 0;
    var resSpeed = nextSpeed || prevSpeed || defaultSpeed || 0;
    var resSpeedInMS = resSpeed * 0.2777;

    if (!prevPosition || !resSpeedInMS) {
      return 0;
    }

    var distanceInM = prevPosition.distanceTo(latlng);
    var durationInS = distanceInM / resSpeedInMS;
    var durationInMs = durationInS * 1000;
    return durationInMs;
  },
  _convertPositionToLatLng: function _convertPositionToLatLng(position) {
    var _position$type;

    if ((position === null || position === void 0 ? void 0 : (_position$type = position.type) === null || _position$type === void 0 ? void 0 : _position$type.toLowerCase()) === "point" && position !== null && position !== void 0 && position.coordinates) {
      return L.GeoJSON.coordsToLatLng(position.coordinates);
    } else {
      return L.latLng(position);
    }
  },
  _closePopupIfNeeded: function _closePopupIfNeeded(layer) {
    var layerGroup = this._layerGroupCache.getLayerGroup();

    var popup = layerGroup.getPopup();

    if (layerGroup.isPopupOpen() && popup._source === layer) {
      layerGroup.closePopup();
    }
  },
  _setLayerPosition: function _setLayerPosition(layer, position) {
    var latlng = this._convertPositionToLatLng(position);

    if (!latlng) return;
    layer.setLatLng(latlng);
    layer.options.lastPosition = latlng;
    layer.options.positionLag = 0;
  },
  _stopLayerMoving: function _stopLayerMoving(layer) {
    if (layer instanceof L.Marker.MovingMarker) {
      layer.stop();
    }
  },
  _onMove: function _onMove(e) {
    this._updatePositionLag(e);

    this._onPositionCorrection(e);
  },
  _updatePositionLag: function _updatePositionLag(e) {
    var layer = e.propagatedFrom,
        currentPos = e.latlng;
    if (!layer || !Array.isArray(layer._latlngs)) return;
    var posLength = layer._latlngs.length;
    if (posLength < 2) return;
    var lastPos = layer._latlngs[posLength - 1];

    if (lastPos) {
      var distance = currentPos.distanceTo(lastPos);
      if (distance < 0) distance = 0;
      layer.options.positionLag = distance;
    }
  },
  _onPositionCorrection: function _onPositionCorrection(e) {
    var layer = e.propagatedFrom;
    if (!layer || layer.options.disableCorrection) return;

    var corrected = this._handlePositionCorrection(layer);

    if (!corrected && this.options.zeroSpeedCorrection) {
      this._handleZeroSpeedCorrection(layer);
    }
  },
  _handlePositionCorrection: function _handlePositionCorrection(layer) {
    var positionLag = layer.options.positionLag;
    if (positionLag === null || positionLag === undefined) return;
    var maxPositionLag = this.options.maxPositionLagInM;

    if (positionLag > maxPositionLag) {
      this._stopMovingAndResetToLastPosition(layer);

      return true;
    }

    return false;
  },
  _handleZeroSpeedCorrection: function _handleZeroSpeedCorrection(layer) {
    var _layer$options = layer.options,
        positionLag = _layer$options.positionLag,
        lastSpeed = _layer$options.lastSpeed;
    if (lastSpeed === null || lastSpeed === undefined) return;
    if (lastSpeed > 0) return;
    var useZeroSpeedPositionLag = this.options.useZeroSpeedPositionLag;

    if (positionLag == null || useZeroSpeedPositionLag && positionLag > this.options.maxZeroSpeedPositionLagInM) {
      this._stopMovingAndResetToLastPosition(layer);

      return true;
    }

    return false;
  },
  _stopMovingAndResetToLastPosition: function _stopMovingAndResetToLastPosition(layer) {
    var layerGroup = this._layerGroupCache.getLayerGroup();

    layerGroup.off("move", this._moveHandler);

    this._stopLayerMoving(layer);

    var posLength = layer._latlngs.length;
    var lastPos = layer._latlngs[posLength - 1];

    if (lastPos) {
      this._setLayerPosition(layer, lastPos);
    }

    layerGroup.on("move", this._moveHandler);
  },
  destroy: function destroy() {
    this._layerGroupCache = null;
  }
});

L.tracker = function (layerGroupCache, options) {
  return new L.Tracker(layerGroupCache, options);
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PicketController = /*#__PURE__*/function () {
  function PicketController(map, targetId, targetLayer, startLatLng, dataSource) {
    var _this = this;

    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    _classCallCheck(this, PicketController);

    _defineProperty(this, "options", {
      snapTolerance: 20,
      circleOptions: {
        color: "#45D0B0",
        fill: true,
        fillOpacity: 0.3,
        radius: 8,
        weight: 4
      },
      picketOptions: {
        color: "#EB5757",
        fill: true,
        fillOpacity: 1,
        radius: 2
      },
      tooltipOptions: {
        permanent: true,
        sticky: true,
        direction: "top",
        offset: L.point(0, -15),
        className: "v-map-picket-tooltip"
      },
      showClosestPickets: false,
      fields: {},
      messages: {}
    });

    _defineProperty(this, "processPicket", function (picket) {
      var _this$options$fields = _this.options.fields,
          picketGeometryField = _this$options$fields.picketGeometryField,
          picketTitleField = _this$options$fields.picketTitleField,
          picketOffsetField = _this$options$fields.picketOffsetField;
      var geometry = picket[picketGeometryField];
      var title = picket[picketTitleField];
      var offset = picket[picketOffsetField];

      if (!geometry) {
        return null;
      }

      try {
        var mapObject = L.GeoJSON.geometryToLayer(geometry);

        if (typeof mapObject.getLatLng === "function") {
          var latlng = mapObject.getLatLng();
          var closestLatLng = L.GeometryUtil.closest(_this.map, _this.targetLayer, latlng, false);

          if (closestLatLng) {
            var picketMarker = null;

            if (_this.options.showClosestPickets) {
              picketMarker = L.circleMarker(closestLatLng.clone(), _objectSpread$3({}, _this.options.picketOptions)).addTo(_this.map);
            }

            return {
              latlng: latlng,
              closestLatLng: closestLatLng,
              picketMarker: picketMarker,
              title: title || null,
              offset: offset || 0
            };
          }
        }
      } catch (e) {
        L.leafletUtil.error(e);
      }

      return null;
    });

    if (options.snapTolerance !== undefined) {
      this.options.snapTolerance = options.snapTolerance;
    }

    if (options.fields !== undefined) {
      this.options.fields = _objectSpread$3({}, options.fields);
    }

    if (options.messages !== undefined) {
      this.options.messages = _objectSpread$3({}, options.messages);
    }

    if (options.showClosestPickets !== undefined) {
      this.options.showClosestPickets = options.showClosestPickets;
    }

    this.map = map;
    this.targetId = targetId;
    this.targetLayer = targetLayer;
    this.pickets = [];
    this.isDestroyed = false;
    this.loading = false;
    map.on("mousemove", this.handleMouseMove, this);
    var _this$options = this.options,
        circleOptions = _this$options.circleOptions,
        tooltipOptions = _this$options.tooltipOptions;
    this.circleMarker = L.circleMarker([0, 0], _objectSpread$3(_objectSpread$3({}, circleOptions), options.circleOptions)).bindTooltip("", _objectSpread$3(_objectSpread$3({}, tooltipOptions), options.tooltipOptions));
    this.updatePositionAndDestroyIfNeeded(startLatLng);

    if (this.isDestroyed) {
      return;
    }

    this.circleMarker.addTo(this.map).openTooltip();

    if (dataSource) {
      this.fetchPickets(dataSource);
    } else {
      this.updateTooltip();
    }
  }

  _createClass(PicketController, [{
    key: "refresh",
    value: function refresh(targetLayer, dataSource) {
      if (this.isDestroyed) return;
      this.targetLayer = targetLayer;
      this.clearPickets();
      var currentLatLng = this.circleMarker.getLatLng();
      this.updatePositionAndDestroyIfNeeded(currentLatLng);
      if (this.isDestroyed) return;

      if (dataSource) {
        if (!this.loading) {
          this.fetchPickets(dataSource);
        }
      } else {
        this.updateTooltip();
      }
    }
  }, {
    key: "updatePositionAndDestroyIfNeeded",
    value: function updatePositionAndDestroyIfNeeded(latlng) {
      var snapTolerance = this.options.snapTolerance;
      var closestLatLng = L.GeometryUtil.closestLayerSnap(this.map, [this.targetLayer], latlng, snapTolerance, false);

      if (closestLatLng) {
        this.circleMarker.setLatLng(closestLatLng.latlng);
      } else {
        this.destroy();
      }
    }
  }, {
    key: "setTooltipLoading",
    value: function setTooltipLoading() {
      this.circleMarker.setTooltipContent("<span class='v-map-picket-tooltip__loading'></span>");
    }
  }, {
    key: "fetchPickets",
    value: function () {
      var _fetchPickets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dataSource) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.loading = true;
                this.setTooltipLoading();
                _context.next = 5;
                return dataSource(this.targetId);

              case 5:
                response = _context.sent;

                if (!this.isDestroyed) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                this.pickets = response.map(this.processPicket).filter(function (item) {
                  return !!item;
                }).sort(function (a, b) {
                  return a.offset - b.offset;
                });
                this.updateTooltip();
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                L.leafletUtil.error(_context.t0);
                this.updateTooltip();

              case 16:
                _context.prev = 16;
                this.loading = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12, 16, 19]]);
      }));

      function fetchPickets(_x) {
        return _fetchPickets.apply(this, arguments);
      }

      return fetchPickets;
    }()
  }, {
    key: "clearPickets",
    value: function clearPickets() {
      this.pickets.forEach(function (picket) {
        if (picket.picketMarker) {
          picket.picketMarker.remove();
        }
      });
      this.pickets = [];
    }
  }, {
    key: "updateTooltip",
    value: function updateTooltip() {
      var messages = this.options.messages;

      if (!this.pickets.length) {
        this.circleMarker.setTooltipContent("<span>".concat(messages.noPickets, "</span>"));
        return;
      }

      var picketName = null;
      var distanceFromStart = 0;
      var distanceToPicket = 0;
      var result = this.findClosestPicket(this.circleMarker.getLatLng());

      if (result) {
        picketName = result.picket.title;
        distanceFromStart = result.isBefore ? result.picket.offset - result.distance : result.picket.offset + result.distance;
        distanceToPicket = result.distance;
      }

      var localizedDistanceFromStart = this.localizeUnits(L.GeometryUtil.readableDistance(Math.abs(distanceFromStart), true));
      var localizedDistanceToPicket = this.localizeUnits(L.GeometryUtil.readableDistance(Math.abs(distanceToPicket), true));
      var distanceFromStartSign = distanceFromStart < 0 ? "-" : "";
      var distanceFromStartMessage = L.Util.template(messages.distanceFromStart, {
        distance: " "
      }) + "<strong>".concat(distanceFromStartSign + localizedDistanceFromStart, "</strong>");
      var message = "";

      if (messages.headerText) {
        message += "<span class='v-map-picket-tooltip__header'>";
        message += messages.headerText;
        message += "</span>";
      }

      message += "<span>";
      message += picketName || "";
      message += picketName ? " " : "";
      message += "<strong>";
      message += result.isBefore ? "-" : "+";
      message += localizedDistanceToPicket;
      message += "</strong>";
      message += "</span>";
      message += "<span>".concat(distanceFromStartMessage, "</span>");
      this.circleMarker.setTooltipContent("<div class='v-map-picket-tooltip__content'>".concat(message, "</div>"));
    }
  }, {
    key: "findClosestPicket",
    value: function findClosestPicket(latlng) {
      var result = {
        picket: null,
        distance: null,
        index: -1
      };
      var mindist = Infinity;
      var distance;

      for (var i = 0; i < this.pickets.length; i++) {
        var picket = this.pickets[i];
        distance = latlng.distanceTo(picket.closestLatLng);

        if (distance <= mindist) {
          mindist = distance;
          result.picket = picket;
          result.distance = distance;
          result.index = i;
        }
      }

      if (!result.picket) {
        return null;
      }

      var _this$getStartEndLatL = this.getStartEndLatLng(),
          start = _this$getStartEndLatL.start,
          end = _this$getStartEndLatL.end;

      var firstPicketClosestLatLng = this.pickets[0].closestLatLng;
      var rtl = firstPicketClosestLatLng.distanceTo(start) > firstPicketClosestLatLng.distanceTo(end);
      var beforePicket = this.pickets[result.index - 1];
      var picketClosestLatLng = result.picket.closestLatLng;
      result.isBefore = this.isBefore(latlng, picketClosestLatLng, beforePicket ? beforePicket.closestLatLng : start);

      if (rtl) {
        result.isBefore = !result.isBefore;
      }

      return result;
    }
  }, {
    key: "isBefore",
    value: function isBefore(latlng, relativeLatLng, beforeRelativeLatlng) {
      return latlng.distanceTo(beforeRelativeLatlng) < relativeLatLng.distanceTo(beforeRelativeLatlng);
    }
  }, {
    key: "getStartEndLatLng",
    value: function getStartEndLatLng() {
      var latlngs = this.targetLayer.getLatLngs();
      var lastIndex = latlngs.length - 1;
      return {
        start: latlngs[0] && Array.isArray(latlngs[0]) ? latlngs[0][0] : latlngs[0],
        end: latlngs[lastIndex] && Array.isArray(latlngs[lastIndex]) ? latlngs[lastIndex][latlngs[lastIndex].length - 1] : latlngs[lastIndex]
      };
    }
  }, {
    key: "localizeUnits",
    value: function localizeUnits(str) {
      var units = this.options.messages.units;
      if (!units) return str;
      return str.replace("ha", units.ha).replace("km", units.km).replace("m", units.m);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      if (this.isDestroyed) return;
      this.updatePositionAndDestroyIfNeeded(e.latlng);

      if (!this.loading && !this.isDestroyed) {
        this.updateTooltip();
      }
    }
  }, {
    key: "hasTargetId",
    value: function hasTargetId(targetId) {
      return this.targetId === targetId;
    }
  }, {
    key: "hasTargetLayer",
    value: function hasTargetLayer(layer) {
      return this.targetLayer === layer;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.isDestroyed) {
        this.isDestroyed = true;
        this.circleMarker.remove();
        this.clearPickets();
        this.map.off("mousemove", this.handleMouseMove, this);
        this.map = this.circleMarker = this.targetLayer = null;
      }
    }
  }]);

  return PicketController;
}();

L.PicketController = PicketController;

L.picketController = function (map, targetId, targetLayer, startLatLng, dataSource) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  return new L.PicketController(map, targetId, targetLayer, startLatLng, dataSource, options);
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Time = /*#__PURE__*/function () {
  function Time(seconds) {
    _classCallCheck(this, Time);

    _defineProperty(this, "units", {
      hours: "h",
      minutes: "min"
    });

    this.hours = Math.floor(seconds / 3600);
    this.minutes = Math.floor((seconds - this.hours * 3600) / 60);
    this.seconds = seconds - this.hours * 3600 - this.minutes * 60;
  }

  _createClass(Time, [{
    key: "setUnits",
    value: function setUnits(units) {
      this.units = units;
      return this;
    }
  }, {
    key: "toHumanFormat",
    value: function toHumanFormat() {
      var _this$units = this.units,
          hours = _this$units.hours,
          minutes = _this$units.minutes;
      return this.hours > 0 ? "".concat(this.hours, " ").concat(hours, " ").concat(this.minutes, " ").concat(minutes) : "".concat(this.minutes, " ").concat(minutes);
    }
  }]);

  return Time;
}();

var RouteController = /*#__PURE__*/function () {
  function RouteController(map, dataSource) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, RouteController);

    _defineProperty(this, "options", {
      startMarkerDivIcon: {
        className: "leaflet-control-routes-start-marker",
        iconSize: L.point(44, 50),
        iconAnchor: L.point(44 / 2, 44),
        tooltipAnchor: L.point(0, -40)
      },
      endMarkerDivIcon: {
        className: "leaflet-control-routes-end-marker",
        iconSize: L.point(44, 50),
        iconAnchor: L.point(44 / 2, 44),
        tooltipAnchor: L.point(0, -40)
      },
      lineStyle: {
        color: "#759EFA",
        weight: 4
      },
      altLineStyle: {
        color: "#B7BACC",
        weight: 4
      },
      tooltipOptions: {
        permanent: true,
        direction: "top",
        offset: L.point(0, 0),
        interactive: true,
        className: "leaflet-control-routes-tooltip"
      },
      messages: {
        noData: "",
        totalDistance: "",
        totalTime: "",
        units: {}
      },
      markerPane: null,
      overlayPane: null,
      fields: {
        routeTotalDistance: "totalDistance",
        routeTotalTime: "totalTime",
        routeStartPoint: "startPoint",
        routeEndPoint: "endPoint",
        routeLatLngs: "latlngs",
        routeIsAlternative: "alt"
      }
    });

    this.initOptions(options);
    this.map = map;
    this.dataSource = dataSource;
    this.events = {};
    this.prevCursor = null;
    this.enabled = false;
    this.loading = false;
    this.isDestroyed = false;
    this.routeData = [];
    this.currentRoute = null;
    this.startMarker = null;
    this.endMarker = null;
    this.layerGroup = L.featureGroup();
    this.map.addLayer(this.layerGroup);

    this._enable();
  }

  _createClass(RouteController, [{
    key: "initOptions",
    value: function initOptions(options) {
      if (options !== null && options !== void 0 && options.messages) {
        this.options.messages = _objectSpread$2(_objectSpread$2({}, this.options.messages), options.messages);
      }

      if (options !== null && options !== void 0 && options.fields) {
        this.options.fields = _objectSpread$2(_objectSpread$2({}, this.options.fields), options.fields);
      }

      this.options.markerPane = options === null || options === void 0 ? void 0 : options.markerPane;
      this.options.overlayPane = options === null || options === void 0 ? void 0 : options.overlayPane;
    }
  }, {
    key: "_enable",
    value: function _enable() {
      if (this.enabled) return;
      this.map.on("click", this._onClick, this);

      this._changeCursor();

      this.enabled = true;
    }
  }, {
    key: "_disable",
    value: function _disable() {
      if (!this.enabled) return;
      this.map.off("click", this._onClick, this);

      this._restoreCursor();

      this.enabled = false;
    }
  }, {
    key: "_startRoute",
    value: function _startRoute(latlng) {
      this.startMarker = L.marker(latlng, this._getMarkerOptions(true));
      this.layerGroup.addLayer(this.startMarker);
      this.fire(RouteController.ROUTE_START, {
        latlng: latlng
      });
    }
  }, {
    key: "_endRoute",
    value: function _endRoute(latlng) {
      this.endMarker = L.marker(latlng, this._getMarkerOptions(false));
      this.layerGroup.addLayer(this.endMarker);

      this._disable();

      this.fire(RouteController.ROUTE_END, {
        latlng: latlng
      });
    }
  }, {
    key: "_getMarkerOptions",
    value: function _getMarkerOptions(isStart) {
      var _this$options = this.options,
          startMarkerDivIcon = _this$options.startMarkerDivIcon,
          endMarkerDivIcon = _this$options.endMarkerDivIcon,
          markerPane = _this$options.markerPane;
      var opt = {
        icon: L.divIcon(isStart ? startMarkerDivIcon : endMarkerDivIcon)
      };

      if (markerPane) {
        opt.pane = markerPane;
      }

      return opt;
    }
  }, {
    key: "_getPolylineOptions",
    value: function _getPolylineOptions() {
      var _this$options2 = this.options,
          lineStyle = _this$options2.lineStyle,
          overlayPane = _this$options2.overlayPane;

      var opt = _objectSpread$2({}, lineStyle);

      if (overlayPane) {
        opt.pane = overlayPane;
      }

      return opt;
    }
  }, {
    key: "_getAltPolylineOptions",
    value: function _getAltPolylineOptions() {
      var _this$options3 = this.options,
          altLineStyle = _this$options3.altLineStyle,
          overlayPane = _this$options3.overlayPane;

      var opt = _objectSpread$2({}, altLineStyle);

      if (overlayPane) {
        opt.pane = overlayPane;
      }

      return opt;
    }
  }, {
    key: "_routeData",
    value: function _routeData() {
      if (!this.dataSource || !this.startMarker || !this.endMarker) return;

      this._createEndRouteTooltip();

      var startLatlng = L.LatLngUtil.cloneLatLng(this.startMarker.getLatLng());
      var stopLatlng = L.LatLngUtil.cloneLatLng(this.endMarker.getLatLng());
      var zoom = this.map.getZoom();

      this._fetchData(startLatlng, stopLatlng, zoom);
    }
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      if (!this.startMarker) {
        this._startRoute(e.latlng);
      } else if (!this.endMarker) {
        this._endRoute(e.latlng);

        this._routeData();
      }
    }
  }, {
    key: "_createEndRouteTooltip",
    value: function _createEndRouteTooltip() {
      if (this.endMarker) {
        this.endMarker.bindTooltip("", this.options.tooltipOptions);

        this._preventTooltipClick(this.endMarker.getTooltip());
      }
    }
  }, {
    key: "_createStartRouteTooltip",
    value: function _createStartRouteTooltip() {
      if (this.startMarker) {
        this.startMarker.bindTooltip("", this.options.tooltipOptions);

        this._preventTooltipClick(this.startMarker.getTooltip());
      }
    }
  }, {
    key: "_preventTooltipClick",
    value: function _preventTooltipClick(tooltip) {
      var _this = this;

      if (!tooltip || !tooltip.getElement()) return;
      tooltip.getElement().addEventListener("click", function (e) {
        _this._stopEvent(e);
      });
    }
  }, {
    key: "_fetchData",
    value: function () {
      var _fetchData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(startLatlng, stopLatlng, zoom) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (this.dataSource) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this.loading = true;

                this._setTooltipLoading();

                _context.next = 7;
                return this.dataSource(startLatlng, stopLatlng, zoom);

              case 7:
                response = _context.sent;

                if (!this.isDestroyed) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                this.routeData = Array.isArray(response) ? response : [];

                this._crearePolylines(this.routeData);

                this._selectPrimaryCurrentRoute(this.routeData);

                this._updateTooltip();

                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                L.leafletUtil.error(_context.t0);

                this._updateTooltip();

              case 20:
                _context.prev = 20;
                this.loading = false;
                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16, 20, 23]]);
      }));

      function _fetchData(_x, _x2, _x3) {
        return _fetchData2.apply(this, arguments);
      }

      return _fetchData;
    }()
  }, {
    key: "_crearePolylines",
    value: function _crearePolylines(routeData) {
      var _this2 = this;

      var fields = this.options.fields;

      var createPolyline = function createPolyline(r) {
        var latlngs = r[fields.routeLatLngs];

        if (Array.isArray(latlngs)) {
          var options = r[fields.routeIsAlternative] ? _this2._getAltPolylineOptions() : _this2._getPolylineOptions();
          var layer = L.polyline(latlngs, options);

          _this2.layerGroup.addLayer(layer);

          r.layer = layer;
        }
      };

      routeData.filter(function (r) {
        return r[fields.routeIsAlternative];
      }).forEach(createPolyline);
      routeData.filter(function (r) {
        return !r[fields.routeIsAlternative];
      }).forEach(createPolyline);
    }
  }, {
    key: "_selectPrimaryCurrentRoute",
    value: function _selectPrimaryCurrentRoute(routeData) {
      var fields = this.options.fields;
      this.currentRoute = routeData.filter(function (r) {
        return !r[fields.routeIsAlternative];
      })[0];
    }
  }, {
    key: "_setTooltipLoading",
    value: function _setTooltipLoading() {
      if (this.endMarker) {
        this.endMarker.setTooltipContent("<span class='leaflet-control-routes-tooltip__loading'></span>");
      }
    }
  }, {
    key: "_updateTooltip",
    value: function _updateTooltip() {
      if (!this.endMarker || !this.startMarker) return;
      var messages = this.options.messages;

      if (!this.currentRoute) {
        this.endMarker.setTooltipContent(this._renderTooltipNoData(messages.noData));
        return;
      }

      var fields = this.options.fields;
      var totalDistance = this.currentRoute[fields.routeTotalDistance];
      var totalTime = this.currentRoute[fields.routeTotalTime];
      var startPoint = this.currentRoute[fields.routeStartPoint];
      var endPoint = this.currentRoute[fields.routeEndPoint];

      if (startPoint) {
        if (!this.startMarker.getTooltip()) {
          this._createStartRouteTooltip();
        }

        this.startMarker.setTooltipContent(this._renderTooltipHeader(startPoint));
      }

      var lines = [];
      var headerText = null;

      if (endPoint) {
        headerText = endPoint;
      }

      if (totalDistance != null && messages.totalDistance) {
        var localizedTotalDistance = this._localizeUnits(L.GeometryUtil.readableDistance(totalDistance, true));

        lines.push({
          text: L.Util.template(messages.totalDistance, {
            distance: " "
          }),
          value: localizedTotalDistance
        });
      }

      if (totalTime != null && messages.totalTime) {
        var time = new Time(totalTime);
        time.setUnits(messages.units);
        lines.push({
          text: L.Util.template(messages.totalTime, {
            time: " "
          }),
          value: time.toHumanFormat()
        });
      }

      this.endMarker.setTooltipContent(this._renderTooltipContent(lines, headerText));
    }
  }, {
    key: "_renderTooltipNoData",
    value: function _renderTooltipNoData(noDataMessage) {
      return this._renderTooltipContent([noDataMessage]);
    }
  }, {
    key: "_renderTooltipContent",
    value: function _renderTooltipContent(lines) {
      var _this3 = this;

      var headerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var wrap = this._renderTooltipWrap();

      wrap.appendChild(this._renderTooltipCloseButton());

      if (headerText) {
        wrap.appendChild(this._renderTooltipHeader(headerText));
      }

      (lines || []).forEach(function (item) {
        if (typeof item === "string") {
          wrap.appendChild(_this3._renderTooltipLine(item));
        } else {
          wrap.appendChild(_this3._renderTooltipLine(item.text, item.value));
        }
      });
      return wrap;
    }
  }, {
    key: "_renderTooltipHeader",
    value: function _renderTooltipHeader(text) {
      var span = document.createElement("span");
      span.className = "leaflet-control-routes-tooltip__header";
      span.innerText = text;
      return span;
    }
  }, {
    key: "_renderTooltipLine",
    value: function _renderTooltipLine(text) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var span = document.createElement("span");
      span.innerText = text;

      if (value) {
        var strong = document.createElement("strong");
        strong.innerText = value;
        span.appendChild(strong);
      }

      return span;
    }
  }, {
    key: "_renderTooltipWrap",
    value: function _renderTooltipWrap() {
      var wrap = document.createElement("div");
      wrap.className = "leaflet-control-routes-tooltip__content";
      return wrap;
    }
  }, {
    key: "_renderTooltipCloseButton",
    value: function _renderTooltipCloseButton() {
      var _this4 = this;

      var closeButton = document.createElement("div");
      closeButton.className = "leaflet-control-routes-tooltip__close-button";
      closeButton.addEventListener("click", function (e) {
        _this4._stopEvent(e);

        _this4.fire(RouteController.ROUTE_CLOSE);

        _this4.destroy();
      });
      return closeButton;
    }
  }, {
    key: "_localizeUnits",
    value: function _localizeUnits(str) {
      var units = this.options.messages.units;
      if (!units) return str;
      return str.replace("ha", units.ha).replace("km", units.km).replace("m", units.m);
    }
  }, {
    key: "_stopEvent",
    value: function _stopEvent(e) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, {
    key: "_changeCursor",
    value: function _changeCursor() {
      var container = this.map.getContainer();
      if (!container) return;
      var style = container.style;
      this.prevCursor = style.cursor;
      style.cursor = RouteController.CURSOR;
    }
  }, {
    key: "_restoreCursor",
    value: function _restoreCursor() {
      var container = this.map.getContainer();
      if (!container || this.prevCursor === null) return;
      container.style.cursor = this.prevCursor;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.isDestroyed) {
        this.isDestroyed = true;

        this._disable();

        this.map.removeLayer(this.layerGroup);
        this.layerGroup.clearLayers();
        this.map = null;
        this.dataSource = null;
        this.events = null;
        this.startMarker = null;
        this.endMarker = null;
        this.layerGroup = null;
        this.routeData = null;
        this.currentRoute = null;
      }
    }
  }, {
    key: "on",
    value: function on(eventName, listener) {
      if (!this.events[eventName]) {
        this.events[eventName] = [];
      }

      this.events[eventName].push(listener);
    }
  }, {
    key: "off",
    value: function off(eventName, listener) {
      if (!listener) {
        delete this.events[eventName];
      } else if (this.events[eventName]) {
        var listeners = this.events[eventName];
        var removeIndex = listeners.indexOf(listener);

        if (removeIndex !== -1) {
          listeners.splice(removeIndex, 1);
        }
      }
    }
  }, {
    key: "fire",
    value: function fire(eventName, event) {
      if (this.events[eventName]) {
        this.events[eventName].forEach(function (l) {
          return l(event);
        });
      }
    }
  }]);

  return RouteController;
}();

_defineProperty(RouteController, "ROUTE_START", "routestart");

_defineProperty(RouteController, "ROUTE_END", "routeend");

_defineProperty(RouteController, "ROUTE_CLOSE", "routeclose");

_defineProperty(RouteController, "CURSOR", "crosshair");

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RoutesController = /*#__PURE__*/function () {
  function RoutesController(map, dataSource) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, RoutesController);

    this.map = map;
    this.dataSource = dataSource;
    this.routes = [];
    this.options = options;
  }

  _createClass(RoutesController, [{
    key: "setDataSource",
    value: function setDataSource(dataSource) {
      this.dataSource = dataSource;
    }
  }, {
    key: "mergeOptions",
    value: function mergeOptions(options) {
      this.options = _objectSpread$1(_objectSpread$1({}, this.options), options);
    }
  }, {
    key: "enable",
    value: function enable() {
      this.createRoute();
    }
  }, {
    key: "disable",
    value: function disable() {
      this.routes.forEach(function (r) {
        return r.destroy();
      });
      this.routes = [];
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.map = null;
      this.dataSource = null;
    }
  }, {
    key: "createRoute",
    value: function createRoute() {
      var _this = this;

      var route = new RouteController(this.map, this.dataSource, this.options);
      route.on("routestart", function () {
        if (_this.options.singleRoute) {
          _this.singleRoute(route);
        }
      });
      route.on("routeend", function () {
        return _this.createRoute();
      });
      route.on("routeclose", function () {
        return _this.removeRoute(route);
      });
      this.routes.push(route);
    }
  }, {
    key: "removeRoute",
    value: function removeRoute(route) {
      var index = this.routes.indexOf(route);

      if (index !== -1) {
        this.routes.splice(index, 1);
      }
    }
  }, {
    key: "singleRoute",
    value: function singleRoute(route) {
      this.routes.filter(function (r) {
        return r !== route;
      }).forEach(function (r) {
        return r.destroy();
      });
      this.routes = [route];
    }
  }]);

  return RoutesController;
}();

L.RoutesController = RoutesController;

L.routesController = function (map, dataSource) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new L.RoutesController(map, dataSource, options);
};

L.Ruler = L.Layer.extend({
  options: {
    pane: "overlayPane",
    circleStyle: {
      color: "#6E9EFB",
      radius: 4,
      fill: true,
      fillOpacity: 1
    },
    lineStyle: {
      color: "#6E9EFB",
      dashArray: "1,6"
    },
    closePathStyle: {
      color: "#ffed00"
    },
    lastCircleStyle: {
      color: "#b7b7b7"
    },
    pointTooltip: {
      permanent: true,
      className: "leaflet-control-ruler-point-tooltip"
    },
    resultTooltip: {
      permanent: true,
      className: "leaflet-control-ruler-result-tooltip"
    },
    movingTooltip: {
      permanent: true,
      sticky: true,
      offset: L.point(0, -40),
      className: "leaflet-control-ruler-moving-tooltip"
    },
    cursor: "crosshair",
    longPressDelay: 500,
    moveInfo: false,
    lengthLabel: "Distance:",
    angleLabel: "Bearing:",
    areaLabel: "Area:",
    localizeUnits: false,
    unitLabels: {
      "km²": "km²",
      ha: "ha",
      "m²": "m²",
      km: "km",
      m: "m"
    }
  },
  initialize: function initialize(options) {
    var _this = this;

    L.Control.prototype.initialize.call(this, options);
    var _this$options = this.options,
        pane = _this$options.pane,
        circleStyle = _this$options.circleStyle,
        lineStyle = _this$options.lineStyle,
        movingTooltip = _this$options.movingTooltip;
    circleStyle.pane = pane;
    lineStyle.pane = pane;
    this._layerGroup = new L.FeatureGroup();
    this._movingLayerGroup = new L.FeatureGroup();
    this._movingCircle = new L.CircleMarker([0, 0], circleStyle);
    this._movingLine = new L.Polyline([], lineStyle);

    this._movingCircle.bindTooltip("", movingTooltip);

    this._movingLayerGroup.addLayer(this._movingLine);

    this._movingLayerGroup.addLayer(this._movingCircle);

    this._measure = new L.Ruler.Measure();
    this._closePathPointHandler = new L.Ruler.PointHandler(function (latLng) {
      return _this._detectClosePath(latLng);
    });
    this._lastPointHandler = new L.Ruler.PointHandler(function (latLng) {
      return _this._detectLastPoint(latLng);
    });
    this._prevCursor = null;
  },
  onAdd: function onAdd(map) {
    map.addLayer(this._layerGroup);
    return this;
  },
  onRemove: function onRemove(map) {
    this.disable();
    map.removeLayer(this._layerGroup);
    return this;
  },
  isEnabled: function isEnabled() {
    return !!this._enabled;
  },
  enable: function enable() {
    var map = this._map;
    if (!map || this._enabled) return;
    map.on("click", this._onClick, this);
    map.on("mousemove", this._onMouseMove, this);
    map.on("mouseup", this._onMouseUp, this);
    map.on("mousedown", this._onMouseDown, this);
    map.on("zoom", this._onZoom, this);
    map.on("move", this._onMove, this);

    this._updateCircleRadiusInM(map);

    this._changeCursor(map);

    this._resetPointHandlers();

    this._enabled = true;
  },
  disable: function disable() {
    var map = this._map;
    if (!map || !this._enabled) return;
    map.removeLayer(this._movingLayerGroup);
    map.off("click", this._onClick, this);
    map.off("mousemove", this._onMouseMove, this);
    map.off("mouseup", this._onMouseUp, this);
    map.off("mousedown", this._onMouseDown, this);
    map.off("zoom", this._onZoom, this);
    map.off("move", this._onMove, this);

    this._restoreCursor(map);

    this._resetPointHandlers();

    this._enabled = false;
  },
  _resetPointHandlers: function _resetPointHandlers() {
    this._closePathPointHandler.reset();

    this._lastPointHandler.reset();
  },
  clear: function clear() {
    this._layerGroup.clearLayers();

    this._measure.clear();

    if (this._map) {
      this._map.removeLayer(this._movingLayerGroup);
    }
  },
  _skipClick: function _skipClick(flag) {
    this._clickSkip = flag;
  },
  _checkClickSkip: function _checkClickSkip() {
    if (this._clickSkip) {
      this._clickSkip = false;
      return true;
    }

    return false;
  },
  _startMeasure: function _startMeasure(latLng) {
    this._measure.add(latLng);

    var lastMeasure = this._measure.last();

    var circle = this._createCircle(lastMeasure.point);

    this._layerGroup.addLayer(circle);

    this._tryReorderMovingLayers();

    this.fire("rulermeasure", {
      measure: lastMeasure
    });
  },
  _nextMeasure: function _nextMeasure(latLng) {
    this._measure.add(latLng);

    var lastMeasure = this._measure.last();

    var prevPoint = this._measure.prev().point;

    var nextPoint = lastMeasure.point;

    var circle = this._createCircle(nextPoint);

    circle.bindTooltip(this._getMeasureText(lastMeasure), this.options.pointTooltip);

    var line = this._createLine(prevPoint, nextPoint);

    this._layerGroup.addLayer(line);

    this._layerGroup.addLayer(circle);

    circle.openTooltip();

    this._tryReorderMovingLayers();

    this.fire("rulermeasure", {
      measure: lastMeasure
    });
  },
  _endMeasure: function _endMeasure(latLng) {
    var detectLastPoint = false;

    if (this._detectClosePath(latLng)) {
      this._measure.closePath();
    } else if (this._detectLastPoint(latLng)) {
      detectLastPoint = true;
    } else {
      this._measure.add(latLng);
    }

    if (detectLastPoint && this._measure.one()) {
      this.clear();
      this.fire("rulermeasurecancel");
      return;
    }

    if (detectLastPoint) {
      var _lastMeasure = this._measure.last();

      var lastPoint = _lastMeasure.point;

      var _measureText = this._getResultMeasureText(_lastMeasure);

      var _circle = this._findLayerByLatLng(this._layerGroup, lastPoint);

      if (_circle) {
        _circle.setStyle(this.options.circleStyle).unbindTooltip().bindTooltip(_measureText, this.options.resultTooltip).openTooltip();
      }

      this._tryReorderMovingLayers();

      this.disable();
      this.fire("rulermeasureend", {
        measure: _lastMeasure
      });
      return;
    }

    var lastMeasure = this._measure.last();

    var prevPoint = this._measure.prev().point;

    var nextPoint = lastMeasure.point;

    var measureText = this._getResultMeasureText(lastMeasure);

    var circle = this._createCircle(nextPoint);

    circle.bindTooltip(measureText, this.options.resultTooltip);

    var line = this._createLine(prevPoint, nextPoint);

    this._layerGroup.addLayer(line);

    this._layerGroup.addLayer(circle);

    circle.openTooltip();

    this._tryReorderMovingLayers();

    this.disable();
    this.fire("rulermeasureend", {
      measure: lastMeasure
    });
  },
  _moveMeasure: function _moveMeasure(latLng) {
    var map = this._map;

    if (!map || this._measure.isEmpty()) {
      return;
    }

    this._measure.add(latLng);

    var prevMeasure = this._measure.prev();

    var lastMeasure = this._measure.last();

    this._measure.removeLast();

    var startPoint = prevMeasure.point;
    var endPoint = lastMeasure.point;

    this._movingLine.setLatLngs([startPoint, endPoint]);

    this._movingCircle.setLatLng(endPoint);

    var measureText = this._getMovingMeasureText(lastMeasure);

    this._movingCircle.setTooltipContent(measureText);

    if (!map.hasLayer(this._movingLayerGroup)) {
      map.addLayer(this._movingLayerGroup);

      this._movingCircle.openTooltip();
    }
  },
  _onClick: function _onClick(e) {
    if (!this._mousePressed) {
      return;
    }

    if (this._checkClickSkip()) {
      return;
    }

    if (this._detectClosePath(e.latlng)) {
      this._endMeasure(e.latlng);

      return;
    }

    if (this._detectLastPoint(e.latlng)) {
      this._endMeasure(e.latlng);

      return;
    }

    if (this._measure.isEmpty()) {
      this._startMeasure(e.latlng);
    } else {
      this._nextMeasure(e.latlng);
    }
  },
  _onLongPress: function _onLongPress(latLng) {
    if (this._measure.count() > 0) {
      this._skipClick(true);

      this._endMeasure(latLng);
    }
  },
  _onZoom: function _onZoom() {
    this._updateCircleRadiusInM(this._map);
  },
  _onMove: function _onMove() {
    this._cancelLongPressTimeout();
  },
  _onMouseMove: function _onMouseMove(e) {
    var moveInfo = this.options.moveInfo;

    if (moveInfo) {
      this._moveMeasure(e.latlng);
    }

    this._updatePointHandlers(e.latlng, moveInfo);
  },
  _onMouseUp: function _onMouseUp() {
    this._cancelLongPressTimeout();
  },
  _onMouseDown: function _onMouseDown(e) {
    var _this2 = this;

    var longPressDelay = this.options.longPressDelay;
    var latLng = e.latlng;
    this._mousePressed = true;
    this._longPressTimeout = setTimeout(function () {
      return _this2._onLongPress(latLng);
    }, longPressDelay);
  },
  _cancelLongPressTimeout: function _cancelLongPressTimeout() {
    clearTimeout(this._longPressTimeout);
  },
  _getMeasureText: function _getMeasureText(measure) {
    var totalDistance = this._measure.toDisplay(measure).totalDistance;

    var text = "<span>".concat(this._localizeUnits(totalDistance), "</span>");
    return text;
  },
  _getResultMeasureText: function _getResultMeasureText(measure) {
    var _this$options2 = this.options,
        lengthLabel = _this$options2.lengthLabel,
        areaLabel = _this$options2.areaLabel;

    var displayMeasure = this._measure.toDisplay(measure);

    var text = "<span>".concat(lengthLabel, " ").concat(this._localizeUnits(displayMeasure.totalDistance), "</span>");

    if (measure.area) {
      text += "<span>".concat(areaLabel, " ").concat(this._localizeUnits(displayMeasure.area), "</span>");
    }

    return text;
  },
  _getMovingMeasureText: function _getMovingMeasureText(measure) {
    var _this$options3 = this.options,
        lengthLabel = _this$options3.lengthLabel,
        angleLabel = _this$options3.angleLabel;

    var displayMeasure = this._measure.toDisplay(measure);

    var text = "<span>".concat(angleLabel, " ").concat(displayMeasure.bearing, "</span>");
    text += "<span>".concat(lengthLabel, " ").concat(this._localizeUnits(displayMeasure.totalDistance), "</span>");
    text += "<i>(+".concat(this._localizeUnits(displayMeasure.distance), ")</i>");
    return text;
  },
  _localizeUnits: function _localizeUnits(str) {
    if (!this.options.localizeUnits) return str;
    return str.replace("km²", this.options.unitLabels["km²"]).replace("ha", this.options.unitLabels.ha).replace("m²", this.options.unitLabels["m²"]).replace("km", this.options.unitLabels.km).replace("m", this.options.unitLabels.m);
  },
  _createLine: function _createLine(latLngA, latLngB) {
    return new L.Polyline([latLngA, latLngB], this.options.lineStyle);
  },
  _createCircle: function _createCircle(latLng) {
    return new L.CircleMarker(latLng, this.options.circleStyle);
  },
  _detectClosePath: function _detectClosePath(latLng) {
    if (this._measure.threeAndMore() && this._circleRadiusInM != null) {
      var firstPoint = this._measure.first().point;

      return latLng.distanceTo(firstPoint) <= this._circleRadiusInM;
    }

    return false;
  },
  _detectLastPoint: function _detectLastPoint(latLng) {
    if (this._measure.last() && this._circleRadiusInM != null) {
      var lastPoint = this._measure.last().point;

      return latLng.distanceTo(lastPoint) <= this._circleRadiusInM;
    }

    return false;
  },
  _updatePointHandlers: function _updatePointHandlers(latLng, isMovingInfo) {
    var _this$options4 = this.options,
        circleStyle = _this$options4.circleStyle,
        closePathStyle = _this$options4.closePathStyle,
        lastCircleStyle = _this$options4.lastCircleStyle;

    if (isMovingInfo) {
      if (this._closePathPointHandler.hover(latLng)) {
        this._movingCircle.setStyle(closePathStyle);
      } else if (this._closePathPointHandler.restore()) {
        this._movingCircle.setStyle(circleStyle);
      }

      if (this._lastPointHandler.hover(latLng)) {
        this._movingCircle.setStyle(lastCircleStyle);
      } else if (this._lastPointHandler.restore()) {
        this._movingCircle.setStyle(circleStyle);
      }
    } else {
      if (this._closePathPointHandler.hover(latLng)) {
        var firstMeasure = this._measure.first();

        var circle = this._findLayerByLatLng(this._layerGroup, firstMeasure.point);

        if (circle) {
          circle.setStyle(closePathStyle);

          this._reorderLayer(this._layerGroup, circle);
        }
      } else if (this._closePathPointHandler.restore()) {
        var _firstMeasure = this._measure.first();

        if (_firstMeasure) {
          var _circle2 = this._findLayerByLatLng(this._layerGroup, _firstMeasure.point);

          if (_circle2) {
            _circle2.setStyle(circleStyle);
          }
        }
      }

      if (this._lastPointHandler.hover(latLng)) {
        var lastMeasure = this._measure.last();

        var _circle3 = this._findLayerByLatLng(this._layerGroup, lastMeasure.point);

        if (_circle3) {
          _circle3.setStyle(lastCircleStyle);
        }
      } else if (this._lastPointHandler.restore()) {
        var _lastMeasure2 = this._measure.last();

        if (_lastMeasure2) {
          var _circle4 = this._findLayerByLatLng(this._layerGroup, _lastMeasure2.point);

          if (_circle4) {
            _circle4.setStyle(circleStyle);
          }
        }
      }
    }
  },
  _findLayerByLatLng: function _findLayerByLatLng(layerGroup, latLng) {
    var layers = layerGroup.getLayers();
    return layers.find(function (l) {
      return l.getLatLng && l.getLatLng().equals(latLng);
    });
  },
  _reorderLayer: function _reorderLayer(container, layer) {
    container.removeLayer(layer);
    container.addLayer(layer);
  },
  _tryReorderMovingLayers: function _tryReorderMovingLayers() {
    var moveInfo = this.options.moveInfo;

    if (moveInfo) {
      var circle = this._movingCircle;
      var line = this._movingLine;
      var layerGroup = this._movingLayerGroup;
      layerGroup.removeLayer(circle);
      layerGroup.removeLayer(line);
      layerGroup.addLayer(line);
      layerGroup.addLayer(circle);
    }
  },
  _changeCursor: function _changeCursor(map) {
    var mapContainerStyle = map.getContainer().style;
    this._prevCursor = mapContainerStyle.cursor;
    mapContainerStyle.cursor = this.options.cursor;
  },
  _restoreCursor: function _restoreCursor(map) {
    map.getContainer().style.cursor = this._prevCursor;
  },
  _updateCircleRadiusInM: function _updateCircleRadiusInM(map) {
    var circleStyle = this.options.circleStyle;
    this._circleRadiusInM = this._pxToMetres(map, circleStyle.radius).distanceX;
  },
  _pxToMetres: function _pxToMetres(map, pixels) {
    var centerLatLng = map.getCenter();
    var pointC = map.latLngToContainerPoint(centerLatLng);
    var pointX = [pointC.x + pixels, pointC.y];
    var pointY = [pointC.x, pointC.y + pixels];
    var latLngC = map.containerPointToLatLng(pointC);
    var latLngX = map.containerPointToLatLng(pointX);
    var latLngY = map.containerPointToLatLng(pointY);
    var distanceX = latLngC.distanceTo(latLngX);
    var distanceY = latLngC.distanceTo(latLngY);
    return {
      distanceX: distanceX,
      distanceY: distanceY
    };
  }
});

L.ruler = function (options) {
  return new L.Ruler(options);
};

L.Ruler.Measure = L.Class.extend({
  initialize: function initialize() {
    this._measures = [];
    this._totalDistance = 0;
  },
  add: function add(latLng) {
    var startLatLng = this.last() ? this.last().point : null;
    var endLatLng = L.latLng(latLng);

    this._measures.push(this._calculate(startLatLng, endLatLng));
  },
  remove: function remove(latLng) {
    var _this = this;

    var removedLength = L.leafletUtil.removeArrayElement(this._measures, function (m) {
      return m.point.equals(latLng);
    });

    if (removedLength > 0) {
      var latLngs = this.getLatLngs();
      this.clear();
      latLngs.forEach(function (latLng) {
        return _this.add(latLng);
      });
    }
  },
  removeLast: function removeLast() {
    var removed = this._measures.pop();

    if (removed) {
      this._totalDistance -= removed.distance;
    }
  },
  getAt: function getAt(index) {
    return this._measures[index];
  },
  last: function last() {
    return this._measures[this._measures.length - 1];
  },
  prev: function prev() {
    return this._measures[this._measures.length - 2];
  },
  first: function first() {
    return this._measures[0];
  },
  several: function several() {
    return this._measures.length > 1;
  },
  threeAndMore: function threeAndMore() {
    return this._measures.length > 2;
  },
  one: function one() {
    return this._measures.length === 1;
  },
  count: function count() {
    return this._measures.length;
  },
  isEmpty: function isEmpty() {
    return this._measures.length === 0;
  },
  clear: function clear() {
    this._measures = [];
    this._totalDistance = 0;
  },
  closePath: function closePath() {
    if (this.count() > 0) {
      var startLatLng = this.last().point;
      var endLatLng = this.first().point;

      this._measures.push(this._calculate(startLatLng, endLatLng, true));
    }
  },
  getLatLngs: function getLatLngs() {
    return this._measures.map(function (m) {
      return m.point;
    });
  },
  toDisplay: function toDisplay(_ref) {
    var distance = _ref.distance,
        totalDistance = _ref.totalDistance,
        bearing = _ref.bearing,
        area = _ref.area;
    return {
      distance: L.GeometryUtil.readableDistance(distance, true),
      totalDistance: L.GeometryUtil.readableDistance(totalDistance, true),
      bearing: "".concat(bearing.toFixed(2), " &deg;"),
      area: L.GeometryUtil.readableArea(area, true)
    };
  },
  _calculate: function _calculate(startLatLng, endLatLng, calcArea) {
    if (!startLatLng) {
      return {
        point: endLatLng,
        distance: 0,
        totalDistance: this._totalDistance,
        bearing: 0,
        area: 0
      };
    }

    var distance = startLatLng.distanceTo(endLatLng);
    this._totalDistance += distance;
    var totalDistance = this._totalDistance;
    var bearing = L.GeometryUtil.bearing(startLatLng, endLatLng);
    bearing += bearing < 0 ? 360 : 0;
    var area = 0;

    if (calcArea) {
      var latLngs = [].concat(_toConsumableArray(this.getLatLngs()), [endLatLng]);
      area = L.GeometryUtil.geodesicArea(latLngs);
    }

    return {
      point: endLatLng,
      distance: distance,
      totalDistance: totalDistance,
      bearing: bearing,
      area: area
    };
  }
});

L.ruler.measure = function () {
  return new L.Ruler.Measure();
};

L.Ruler.PointHandler = L.Class.extend({
  initialize: function initialize(hoverPredicate) {
    this._hoverPredicate = hoverPredicate;
    this._hovered = false;
    this._hoverPredicateState = false;
  },
  reset: function reset() {
    this._hovered = false;
    this._hoverPredicateState = false;
  },
  hover: function hover(latLng) {
    this._hoverPredicateState = this._hoverPredicate(latLng);

    if (this._hoverPredicateState) {
      if (!this._hovered) {
        this._hovered = true;
        return true;
      }
    }

    return false;
  },
  restore: function restore() {
    if (this._hovered && !this._hoverPredicateState) {
      this._hovered = false;
      return true;
    }

    return false;
  }
});

L.ruler.pointHandler = function () {
  return new L.Ruler.PointHandler();
};

L.Control.Ruler = L.Control.extend({
  options: {
    position: "topright",
    title: "Ruler",
    ruler: {}
  },
  onAdd: function onAdd() {
    var container = L.DomUtil.create("div", "leaflet-control-ruler leaflet-bar leaflet-control");
    this.link = L.DomUtil.create("a", "leaflet-control-ruler-button", container);
    this.link.href = "#";
    this.link.title = this.options.title;
    L.DomEvent.disableClickPropagation(this.link);
    L.DomEvent.disableScrollPropagation(this.link);
    L.DomEvent.on(this.link, "click", this._toggleMeasure, this);
    this._enabled = false;
    return container;
  },
  onRemove: function onRemove() {
    this._disableMeasure();

    L.DomEvent.off(this.link, "click", this._toggleMeasure, this);
    this.link = null;
    this._container = null;
  },
  _toggleMeasure: function _toggleMeasure(e) {
    this._stopEvent(e);

    if (this._enabled) {
      this._disableMeasure();
    } else {
      this._enableMeasure();
    }
  },
  _enableMeasure: function _enableMeasure() {
    L.DomUtil.addClass(this.link, "leaflet-control-ruler-button--active");
    this._enabled = true;
    this._rulers = [];

    this._createRuler();
  },
  _disableMeasure: function _disableMeasure() {
    L.DomUtil.removeClass(this.link, "leaflet-control-ruler-button--active");
    this._enabled = false;

    this._removeRulers();
  },
  _createRuler: function _createRuler() {
    var _this = this;

    if (!this._map) {
      return;
    }

    var ruler = new L.Ruler(this.options.ruler);
    ruler.on("rulermeasureend", function () {
      return _this._createRuler();
    });

    this._map.addLayer(ruler);

    ruler.enable();

    this._rulers.push(ruler);
  },
  _removeRulers: function _removeRulers() {
    if (this._rulers) {
      this._rulers.forEach(function (ruler) {
        ruler.clear();
        ruler.remove();
      });

      this._rulers = [];
    }
  },
  _stopEvent: function _stopEvent(e) {
    e.preventDefault();
  }
});

L.control.ruler = function (options) {
  return new L.Control.Ruler(options);
};

var _uid = 0;

function genUid() {
  return ++_uid;
}

L.SuperClusterIndex = L.Evented.extend({
  options: {
    minZoom: 0,
    maxZoom: 17,
    minPoints: 2,
    radius: 60,
    extent: 256,
    nodeSize: 64,
    log: false,
    generateId: false,
    fieldMap: {},
    workerFactory: null
  },
  initialize: function initialize(options) {
    var _this = this;

    L.Util.setOptions(this, options);

    if (!this.options.workerFactory) {
      throw new Error("You need to pass option 'workerFactory', which creates background workers");
    }

    this._map = null;
    this._dataLoaded = false;
    this._isRawData = false;
    this._uid = genUid();
    this._errorHandler = L.Util.bind(this._onError, this);
    this._updateHandler = L.Util.bind(this._onUpdate, this);
    this._nonPointsHandler = L.Util.bind(this._onNonPoints, this);
    this._worker = this.options.workerFactory();
    this._rpcProvider = new RpcProvider(function (message, transfer) {
      return _this._worker.postMessage(message, transfer);
    });

    this._worker.onmessage = function (e) {
      return _this._rpcProvider.dispatch(e.data);
    };

    this._rpcProvider.error.addHandler(this._errorHandler);

    this._worker.onerror = this._errorHandler;

    this._rpcProvider.registerSignalHandler("nonPoints", this._nonPointsHandler);
  },
  setMap: function setMap(map) {
    if (!map) {
      if (this._map) {
        this._map.off("moveend", this._updateHandler);
      }

      this._map = null;
      return;
    }

    map.on("moveend", this._updateHandler);
    this._map = map;

    this._onUpdate();
  },
  load: function load(data) {
    this._loadData(data);
  },
  isRawData: function isRawData() {
    return this._isRawData;
  },
  convertRawData: function convertRawData(data) {
    var fieldMap = this.options.fieldMap;
    if (!fieldMap) return;
    var idField = fieldMap.id;
    var titleField = fieldMap.title;
    var descriptionField = fieldMap.description;

    if (idField.from in data) {
      data[idField.to] = data[idField.from];
      data[idField.from] = undefined;
    }

    if (titleField.from in data) {
      data[titleField.to] = data[titleField.from];
      data[titleField.from] = undefined;
    }

    if (descriptionField.from in data) {
      data[descriptionField.to] = data[descriptionField.from];
      data[descriptionField.from] = undefined;
    }
  },
  _getIndexOptions: function _getIndexOptions() {
    return {
      minZoom: this.options.minZoom,
      maxZoom: this.options.maxZoom,
      minPoints: this.options.minPoints,
      radius: this.options.radius,
      extent: this.options.extent,
      nodeSize: this.options.nodeSize,
      log: this.options.log,
      generateId: this.options.generateId,
      geometryField: this.options.fieldMap.geometry
    };
  },
  _loadData: function _loadData(data) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var log, transfer, isRaw, options, payload, count;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              log = _this2.options.log;
              _this2._dataLoaded = false;
              if (log) console.log("[Main]: #%d start load data in %d ms", _this2._uid, +Date.now());
              _this2._isRawData = data instanceof ArrayBuffer;
              transfer = _this2._isRawData ? [data] : undefined;
              isRaw = _this2._isRawData;
              options = _this2._getIndexOptions();
              if (log && isRaw) console.log("[Main]: #%d before transfer %d bytes", _this2._uid, data.byteLength);
              payload = {
                data: data,
                options: options,
                uid: _this2._uid
              };
              _context.next = 12;
              return _this2._rpcProvider.rpc("loadData", payload, transfer);

            case 12:
              count = _context.sent;
              if (log && isRaw) console.log("[Main]: #%d after transfer %d bytes", _this2._uid, data.byteLength);
              _this2._dataLoaded = true;

              _this2.fire("dataLoaded", {
                count: count
              });

              _this2._onUpdate();

              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);

              _this2._onError(_context.t0);

              _this2._dataLoaded = false;

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 19]]);
    }))();
  },
  _getClusters: function _getClusters(bbox, zoom) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this3._rpcProvider.rpc("getClusters", {
                bbox: bbox,
                zoom: zoom
              });

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);

              _this3._onError(_context2.t0);

              return _context2.abrupt("return", []);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }))();
  },
  getClusterExpansionZoom: function getClusterExpansionZoom(clusterId) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this4._rpcProvider.rpc("getClusterExpansionZoom", clusterId);

            case 3:
              return _context3.abrupt("return", _context3.sent);

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);

              _this4._onError(_context3.t0);

              return _context3.abrupt("return", null);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 6]]);
    }))();
  },
  getAllLeaves: function getAllLeaves(clusterId) {
    return this.getLeaves(clusterId, -1, 0);
  },
  getLeaves: function getLeaves(clusterId, limit, offset) {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _this5._rpcProvider.rpc("getLeaves", {
                clusterId: clusterId,
                limit: limit,
                offset: offset
              });

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);

              _this5._onError(_context4.t0);

              return _context4.abrupt("return", []);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 6]]);
    }))();
  },
  _onUpdate: function _onUpdate() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var bounds, bbox, zoom, objects;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(_this6._dataLoaded && _this6._map)) {
                _context5.next = 8;
                break;
              }

              bounds = _this6._map.getBounds();
              bbox = [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()];
              zoom = _this6._map.getZoom();
              _context5.next = 6;
              return _this6._getClusters(bbox, zoom);

            case 6:
              objects = _context5.sent;

              _this6.fire("update", {
                objects: objects
              });

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  _onNonPoints: function _onNonPoints(nonPoints) {
    this.fire("nonPoints", {
      nonPoints: nonPoints
    });
  },
  _onError: function _onError(error) {
    this.fire("error", {
      error: error
    });
  },
  destroy: function destroy() {
    this.clearAllEventListeners();
    this.setMap(null);
    if (this.options.log) console.log("[Main] #%d teminate worker", this._uid);

    this._worker.terminate();

    this._rpcProvider = null;
    this._worker = null;
  }
});

L.superClusterIndex = function (options) {
  return new L.SuperClusterIndex(options);
};

L.SuperClusterGroup = L.FeatureGroup.extend({
  options: {
    indexOptions: {},
    iconClusterCreateFunction: null,
    layerCreateFunction: null,
    updatePopupFunction: null
  },
  initialize: function initialize(options) {
    var _this = this;

    L.Util.setOptions(this, options);
    this._featureGroup = L.featureGroup();

    this._featureGroup.addEventParent(this);

    this._nonClusteringGroup = L.featureGroup();

    this._nonClusteringGroup.addEventParent(this);

    this._index = L.superClusterIndex(this.options.indexOptions);

    this._index.on("error", function (e) {
      return _this.fire("error", e);
    });

    this._index.on("dataLoaded", function (e) {
      return _this.fire("dataLoaded", e);
    });

    this._index.on("update", function (e) {
      return _this._onUpdate(e);
    });

    this._index.on("nonPoints", function (e) {
      return _this._onNonPoints(e);
    });
  },
  loadData: function loadData(data) {
    this._index.load(data);
  },
  addLayer: function addLayer(layer) {
    if (this.hasLayer(layer)) {
      return this;
    }

    this._nonClusteringGroup.addLayer(layer);

    this.fire('layeradd', {
      layer: layer
    });
    return this;
  },
  removeLayer: function removeLayer(layer) {
    if (!this.hasLayer(layer)) {
      return this;
    }

    this._nonClusteringGroup.removeLayer(layer);

    this.fire('layerremove', {
      layer: layer
    });
    return this;
  },
  addLayers: function addLayers(layersArray) {
    for (var i = 0, len = layersArray.length; i < len; i++) {
      this.addLayer(layersArray[i]);
    }

    return this;
  },
  removeLayers: function removeLayers(layersArray) {
    for (var i = 0, len = layersArray.length; i < len; i++) {
      this.removeLayer(layersArray[i]);
    }

    return this;
  },
  clearLayers: function clearLayers() {
    this._featureGroup.clearLayers();

    this._nonClusteringGroup.clearLayers();

    return this;
  },
  getBounds: function getBounds() {
    var bounds = new L.LatLngBounds();
    bounds.extend(this._featureGroup.getBounds());
    bounds.extend(this._nonClusteringGroup.getBounds());
    return bounds;
  },
  eachLayer: function eachLayer(method, context) {
    this._featureGroup.eachLayer(method, context);

    this._nonClusteringGroup.eachLayer(method, context);
  },
  getLayers: function getLayers() {
    var layers = [];
    this.eachLayer(function (l) {
      layers.push(l);
    });
    return layers;
  },
  getLayer: function getLayer(id) {
    var result = this._featureGroup.getLayer(id);

    if (!result) {
      result = this._nonClusteringGroup.getLayer(id);
    }

    return result;
  },
  hasLayer: function hasLayer(layer) {
    return this._featureGroup.hasLayer(layer) || this._nonClusteringGroup.hasLayer(layer);
  },
  onAdd: function onAdd(map) {
    this._featureGroup.addTo(map);

    this._nonClusteringGroup.addTo(map);

    this._index.setMap(map);

    this._bindEvents();
  },
  onRemove: function onRemove(map) {
    this._unbindEvents();

    this._featureGroup.remove();

    this._nonClusteringGroup.remove();

    this._featureGroup.clearLayers();

    this._index.setMap(null);

    this._map = null;
  },
  _onUpdate: function _onUpdate(e) {
    var updatePopupFunction = this.options.updatePopupFunction;
    var objects = e.objects;

    this._featureGroup.clearLayers();

    var layer;
    var points = [];

    for (var i = 0, len = objects.length; i < len; i++) {
      var item = objects[i];

      if (item.properties && item.properties.cluster) {
        layer = this._createCluster(item);
      } else {
        layer = this._createPoint(item);
        if (layer) points.push(layer);
      }

      if (layer) {
        this._featureGroup.addLayer(layer);
      }
    }

    if (updatePopupFunction && points.length > 0) {
      updatePopupFunction(points);
    }
  },
  _createCluster: function _createCluster(data) {
    var _this2 = this;

    var iconClusterCreateFunction = this.options.iconClusterCreateFunction;
    if (!iconClusterCreateFunction) return null;
    var _data$properties = data.properties,
        count = _data$properties.point_count,
        clusterId = _data$properties.cluster_id;
    var icon = iconClusterCreateFunction({
      count: count
    });
    if (!icon) return null;
    var layer = L.GeoJSON.geometryToLayer(data, {
      icon: icon,
      markersInheritOptions: true
    });
    if (!layer) return null;
    layer.options.data = {
      count: count,
      clusterId: clusterId
    };

    layer.getMarkersDataAsync = function () {
      return _this2.getMarkersDataAsync(clusterId);
    };

    return layer;
  },
  getMarkersDataAsync: function getMarkersDataAsync(clusterId) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var result, i, len;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              result = [];

              if (!_this3._index) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return _this3._index.getAllLeaves(clusterId);

            case 4:
              result = _context.sent;

              if (_this3._index.isRawData()) {
                for (i = 0, len = result.length; i < len; i++) {
                  _this3._index.convertRawData(result[i]);
                }
              }

            case 6:
              return _context.abrupt("return", result);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  _createPoint: function _createPoint(data) {
    var layerCreateFunction = this.options.layerCreateFunction;
    if (!layerCreateFunction) return null;

    if (this._index.isRawData()) {
      this._index.convertRawData(data);
    }

    return layerCreateFunction(data);
  },
  _onNonPoints: function _onNonPoints(e) {
    var nonPoints = e.nonPoints;
    var layerCreateFunction = this.options.layerCreateFunction;

    this._nonClusteringGroup.clearLayers();

    if (layerCreateFunction) {
      for (var i = 0, len = nonPoints.length; i < len; i++) {
        var layer = layerCreateFunction(nonPoints[i]);

        if (layer) {
          this._nonClusteringGroup.addLayer(layer);
        }
      }
    }
  },
  _bindEvents: function _bindEvents() {
    this.on("clusterclick", this._onClusterZoom, this);
  },
  _unbindEvents: function _unbindEvents() {
    this.off("clusterclick", this._onClusterZoom, this);
  },
  _onClusterZoom: function _onClusterZoom(e) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var latlng, clusterId, expansionZoom;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!e._prevented) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              latlng = e.latlng, clusterId = e.layer.options.data.clusterId;
              _context2.next = 5;
              return _this4._index.getClusterExpansionZoom(clusterId);

            case 5:
              expansionZoom = _context2.sent;

              if (!(expansionZoom === null || !_this4._map)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return");

            case 8:
              _this4._map.setView(latlng, expansionZoom);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  _isOrIsParent: function _isOrIsParent(el, oel) {
    while (oel) {
      if (el === oel) {
        return true;
      }

      oel = oel.parentNode;
    }

    return false;
  },
  fire: function fire(type, data, propagate) {
    if (data && data.layer instanceof L.Marker && data.layer.options.data && data.layer.options.data.clusterId) {
      if (data.originalEvent && this._isOrIsParent(data.layer._icon, data.originalEvent.relatedTarget)) {
        return;
      }

      type = 'cluster' + type;
    }

    L.FeatureGroup.prototype.fire.call(this, type, data, propagate);
  },
  listens: function listens(type, propagate) {
    return L.FeatureGroup.prototype.listens.call(this, type, propagate) || L.FeatureGroup.prototype.listens.call(this, "cluster".concat(type), propagate);
  },
  destroy: function destroy() {
    this.clearAllEventListeners();

    if (this._index) {
      this._index.destroy();

      this._index = null;
    }
  }
});

L.superClusterGroup = function (options) {
  return new L.SuperClusterGroup(options);
};

L.SvgPattern = L.Class.extend({
  options: {
    x: 0,
    y: 0,
    width: 8,
    height: 8,
    patternUnits: "userSpaceOnUse",
    patternContentUnits: "userSpaceOnUse",
    angle: null,
    patternTransform: null,
    className: null
  },
  initialize: function initialize(options) {
    L.setOptions(this, options);
    L.stamp(this);
  },
  _remove: L.Util.falseFn,
  _updateStyle: L.Util.falseFn,
  _id: function _id() {
    return L.stamp(this);
  },
  _initDom: function _initDom() {
    this._dom = L.SVG.create("pattern");
    var className = this.options.className;

    if (className) {
      L.DomUtil.addClass(this._dom, className);
    }
  },
  _addDom: function _addDom(renderer) {
    if (this._dom && renderer._rootDef) {
      renderer._rootDef.appendChild(this._dom);
    }
  },
  _removeDom: function _removeDom() {
    if (this._dom) {
      L.DomUtil.remove(this._dom);
    }
  },
  _initDef: function _initDef(renderer) {
    if (!renderer._rootDef) {
      renderer._initDef();
    }
  },
  _initFor: function _initFor(renderer) {
    var _this = this;

    if (this._inited) return;

    this._initDef(renderer);

    if (!this._dom) {
      this._initDom();

      this._addDom(renderer);
    }

    renderer.once("remove", function () {
      _this.remove();
    });
    this._inited = true;
  },
  _linkLayer: function _linkLayer(layer) {
    if (layer._path) {
      layer._path.setAttribute("fill", "url(#".concat(this._id(), ")"));
    }
  },
  remove: function remove() {
    this._remove();

    this._removeDom();

    this._dom = null;
    this._inited = false;
  },
  updateStyle: function updateStyle(renderer, layer) {
    this._initFor(renderer);

    var _this$options = this.options,
        x = _this$options.x,
        y = _this$options.y,
        width = _this$options.width,
        height = _this$options.height,
        patternUnits = _this$options.patternUnits,
        patternContentUnits = _this$options.patternContentUnits,
        patternTransform = _this$options.patternTransform,
        angle = _this$options.angle;
    var dom = this._dom;
    dom.setAttribute("id", this._id());
    dom.setAttribute("x", x);
    dom.setAttribute("y", y);
    dom.setAttribute("width", width);
    dom.setAttribute("height", height);
    dom.setAttribute("patternUnits", patternUnits);
    dom.setAttribute("patternContentUnits", patternContentUnits);

    if (patternTransform || angle) {
      var transform = patternTransform ? patternTransform + " " : "";
      transform += angle ? "rotate(" + angle + ") " : "";
      dom.setAttribute("patternTransform", transform);
    } else {
      dom.removeAttribute("patternTransform");
    }

    this._updateStyle(renderer, layer);

    this._linkLayer(layer);
  }
});

L.SVG.include({
  _superUpdateStyle: L.SVG.prototype._updateStyle,
  _superDestroyContainer: L.SVG.prototype._destroyContainer,
  _updateStyle: function _updateStyle(layer) {
    this._superUpdateStyle(layer);

    if (layer.options.fill && layer.options.fillPattern && typeof layer.options.fillPattern.updateStyle === "function") {
      layer.options.fillPattern.updateStyle(this, layer);
    }
  },
  _initDef: function _initDef() {
    this._rootDef = L.SVG.create("defs");

    this._container.appendChild(this._rootDef);
  },
  _destroyContainer: function _destroyContainer() {
    this._superDestroyContainer();

    delete this._rootDef;
  }
});

L.SvgPattern.SvgStripePattern = L.SvgPattern.extend({
  options: {
    color: "#3388ff",
    weight: 4,
    opacity: 1.0,
    spaceColor: "#ffffff",
    spaceWeight: 4,
    spaceOpacity: 0.0
  },
  _updateStyle: function _updateStyle() {
    this._initShapes();

    this._updateShapes();
  },
  _getStripeShapeOpt: function _getStripeShapeOpt() {
    return {
      d: null,
      stroke: true,
      weight: this.options.weight,
      color: this.options.color,
      opacity: this.options.opacity
    };
  },
  _getSpaceShapeOpt: function _getSpaceShapeOpt() {
    return {
      d: null,
      stroke: true,
      weight: this.options.spaceWeight,
      color: this.options.spaceColor,
      opacity: this.options.spaceOpacity
    };
  },
  _initShapes: function _initShapes() {
    if (!this._stripe) {
      this._stripe = new L.SvgPattern.SvgPathPatternShape();
    }

    if (!this._space) {
      this._space = new L.SvgPattern.SvgPathPatternShape();
    }
  },
  _updateShapes: function _updateShapes() {
    if (this._stripe && this._space) {
      L.setOptions(this._stripe, this._getStripeShapeOpt());
      L.setOptions(this._space, this._getSpaceShapeOpt());

      this._updatePathD(this._stripe, this._space);

      this._stripe.update(this);

      this._space.update(this);
    }
  },
  _updatePathD: function _updatePathD(stripeShape, spaceShape) {
    stripeShape.options.d = "M0 ".concat(stripeShape.options.weight / 2, " H ").concat(this.options.width);
    spaceShape.options.d = "M0 ".concat(stripeShape.options.weight + spaceShape.options.weight / 2, " H ").concat(this.options.width);
  },
  _remove: function _remove() {
    if (this._stripe) {
      this._stripe.remove();

      this._stripe = null;
    }

    if (this._space) {
      this._space.remove();

      this._space = null;
    }
  }
});

L.SvgPattern.SvgPatternShape = L.Class.extend({
  options: {
    stroke: true,
    color: "#3388ff",
    weight: 3,
    opacity: 1.0,
    lineCap: "round",
    lineJoin: "round",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: null,
    fillOpacity: 0.2,
    fillRule: "evenodd",
    pointerEvents: null,
    interactive: false,
    className: null
  },
  initialize: function initialize(options) {
    L.setOptions(this, options);
  },
  _initDom: L.Util.falseFn,
  _updateShape: L.Util.falseFn,
  _updateStyle: L.Util.falseFn,
  _initDomElement: function _initDomElement(type) {
    this._dom = L.SVG.create(type);
    var className = this.options.className;

    if (className) {
      L.DomUtil.addClass(this._dom, className);
    }
  },
  _addDom: function _addDom(pattern) {
    if (this._dom && pattern._dom) {
      pattern._dom.appendChild(this._dom);
    }
  },
  _removeDom: function _removeDom() {
    if (this._dom) {
      L.DomUtil.remove(this._dom);
    }
  },
  remove: function remove() {
    this._removeDom();

    this._dom = null;
    this._inited = false;
  },
  _initFor: function _initFor(pattern) {
    if (this._inited) return;

    if (!this._dom) {
      this._initDom();

      this._addDom(pattern);
    }

    this._inited = true;
  },
  updateShape: function updateShape(pattern) {
    this._initFor(pattern);

    this._updateShape(pattern);
  },
  updateStyle: function updateStyle(pattern) {
    this._initFor(pattern);

    var _this$options = this.options,
        stroke = _this$options.stroke,
        color = _this$options.color,
        opacity = _this$options.opacity,
        weight = _this$options.weight,
        lineCap = _this$options.lineCap,
        lineJoin = _this$options.lineJoin,
        dashArray = _this$options.dashArray,
        dashOffset = _this$options.dashOffset,
        fill = _this$options.fill,
        fillColor = _this$options.fillColor,
        fillOpacity = _this$options.fillOpacity,
        fillRule = _this$options.fillRule,
        pointerEvents = _this$options.pointerEvents,
        interactive = _this$options.interactive;
    var dom = this._dom;

    if (stroke) {
      dom.setAttribute("stroke", color);
      dom.setAttribute("stroke-opacity", opacity);
      dom.setAttribute("stroke-width", weight);
      dom.setAttribute("stroke-linecap", lineCap);
      dom.setAttribute("stroke-linejoin", lineJoin);

      if (dashArray) {
        dom.setAttribute("stroke-dasharray", dashArray);
      } else {
        dom.removeAttribute("stroke-dasharray");
      }

      if (dashOffset) {
        dom.setAttribute("stroke-dashoffset", dashOffset);
      } else {
        dom.removeAttribute("stroke-dashoffset");
      }
    } else {
      dom.setAttribute("stroke", "none");
    }

    if (fill) {
      dom.setAttribute("fill", fillColor || color);
      dom.setAttribute("fill-opacity", fillOpacity);
      dom.setAttribute("fill-rule", fillRule || "evenodd");
    } else {
      dom.setAttribute("fill", "none");
    }

    dom.setAttribute("pointer-events", pointerEvents || (interactive ? "visiblePainted" : "none"));

    this._updateStyle(pattern);
  },
  update: function update(pattern) {
    this.updateShape(pattern);
    this.updateStyle(pattern);
  }
});

L.SvgPattern.SvgPathPatternShape = L.SvgPattern.SvgPatternShape.extend({
  options: {
    d: null
  },
  _initDom: function _initDom() {
    this._initDomElement("path");
  },
  _updateShape: function _updateShape() {
    if (this._dom && this.options.d != null) {
      this._dom.setAttribute("d", this.options.d);
    }
  }
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

if (!L.esri) {
  L.esri = {};
}

if (!L.esri.Vector) {
  L.esri.Vector = {};
}

L.esri = _objectSpread(_objectSpread({}, L.esri), esri);
L.esri.Vector = _objectSpread(_objectSpread({}, L.esri.Vector), Vector);
